const PageLang = {

    LoginPage: {
        title: {
            key: 'login',
            English: 'Login with email',
            Hindi: 'अपने खाते में प्रवेश करें'
        },
        sub_title: {
            key: 'sub_login_text',
            English: 'Siddha Guru CSR Portal',
            Hindi: 'अपने खाते में प्रवेश करें'
        },
        inutUserName: {
            usernameLabel: {
                key: 'username',
                English: 'User Name',
                Hindi: 'उपयोगकर्ता नाम'
            },
            usernamePlaceholder: {
                key: 'enter-mailid',
                English: 'Enter Email ID',
                Hindi: 'ईमेल आईडी दर्ज करें'
            }
        },
        inputPassword: {
            passwordLabel: {
                key: 'password',
                English: 'Password',
                Hindi: 'पासवर्ड '
            },
            passwordPlacehoder: {
                key: 'enter-password',
                English: 'Enter Password',
                Hindi: 'पासवर्ड दर्ज करें'
            }
        },
        wrongPassword: {
            English: "Invalid username or password.",
            Hindi: "अमान्य उपयोगकर्ता नाम या पासवर्ड।"
        },
        buttons: {
            submit: {
                key: 'submit',
                English: 'Submit',
                Hindi: 'जमा करें'
            },
            passwordForgot: {
                key: 'forgot-password',
                English: 'Forgot Password ?',
                Hindi: 'पासवर्ड भूल गए ?'
            }
        }
    },

    RegisterButton: {
        English: 'Register',
        Hindi: 'पंजीकरण',
    },

    minister: [
        {
            name: {
                English: 'Sri Sidheshwar Brahmarishi',
                Hindi: 'श्री सिद्धेश्वर ब्रह्मऋषि'
            },
            post: {
                English: 'Guruvar',
                Hindi: 'गुरुवर'
            }
        }

    ],

    homePageTitle: {
        key: 'pageHead',
        value: 'pagehead',
        url: '/home',
        English: 'Sri Siddhguru CSR Portal',
        Hindi: 'श्री सिद्धगुरु सीएसआर पोर्टल',
    },

    aboutUs: {
        English: 'About Ashram',
        Hindi: 'आश्रम के बारे में'
    },
    ourTeam: {
        English: 'Our Team',
        Hindi: 'हमारी टीम'
    },

    aboutFirst: {
        English: 'Corporate Social Responsibility (CSR) is a business approach through which companies integrate social, environmental, and ethical concerns into their operations. It encourages organizations to go beyond financial profits and take responsibility for the well-being of society. CSR promotes initiatives in areas such as education, healthcare, skill development, sanitation, rural development, and environmental sustainability.',
        Hindi: 'कॉरपोरेट सामाजिक उत्तरदायित्व (सीएसआर) एक व्यावसायिक दृष्टिकोण है जिसके माध्यम से कंपनियाँ अपने संचालन में सामाजिक, पर्यावरणीय और नैतिक सरोकारों को एकीकृत करती हैं। यह कंपनी को केवल आर्थिक लाभ से आगे बढ़कर समाज की भलाई की जिम्मेदारी लेने के लिए प्रोत्साहित करता है. सीएसआर के अंतर्गत शिक्षा, स्वास्थ्य, कौशल विकास, स्वच्छता, ग्रामीण विकास और पर्यावरणीय स्थिरता जैसे क्षेत्रों में पहल को बढ़ावा दिया जाता है.'
    },

    aboutSecond: {
        English: 'CSR has been made mandatory under the Companies Act, 2013. As per Section 135 of the Act, companies with a certain turnover, net worth, or profit margin are required to spend a minimum of 2% of their average net profit from the past three years on CSR activities. These activities must align with areas listed in Schedule VII, such as education, healthcare, gender equality, environmental sustainability, rural development, and more.',
        Hindi: 'सीएसआर को कंपनी अधिनियम, 2013 के तहत अनिवार्य बनाया गया है। इस अधिनियम की धारा 135 के अनुसार, जिन कंपनी की वार्षिक आय, निवल संपत्ति या लाभ एक निश्चित सीमा से अधिक है, उन्हें अपने पिछले तीन वर्षों के औसत लाभ का न्यूनतम 2% सीएसआर गतिविधियों पर खर्च करना अनिवार्य है। ये गतिविधियाँ अनुसूची VII में सूचीबद्ध क्षेत्रों जैसे शिक्षा, स्वास्थ्य, लैंगिक समानता, पर्यावरणीय स्थिरता, ग्रामीण विकास आदि के अंतर्गत होनी चाहिए.'
    },

    aboutFourth: {
        English: 'Recognizing the importance of CSR in contributing to the state’s development, the , through the Finance Department, has introduced a comprehensive CSR Portal. This digital platform serves as a centralized interface for all CSR stakeholders—corporate donors, NGO, and government departments—to engage, collaborate, and contribute toward impactful social projects across the state.',
        Hindi: 'सीएसआर की राज्य के विकास में भूमिका को समझते हुए, बिहार सरकार ने वित्त विभाग के माध्यम से एक समग्र सीएसआर पोर्टल की शुरुआत की है। यह डिजिटल प्लेटफॉर्म सभी CSR हितधारकों—कॉरपोरेट सेवा प्रदाता, कार्यान्वयन एजेंसियों और सरकारी विभागों—के लिए एक केंद्रीकृत इंटरफ़ेस के रूप में कार्य करता है, जिससे वे राज्यभर में प्रभावशाली सामाजिक परियोजनाओं में भागीदारी और सहयोग कर सकें.'
    },

    aboutThird: {
        English: 'CSR is not just about philanthropy—it s about integrating social and environmental concerns into a companys operations and interactions. It allows companies to play a positive role in the community, build trust, improve brand reputation, and ensure sustainable development. More importantly, in the Indian context, CSR also helps bridge development gaps by supporting government efforts and working directly with NGO and civil society organizations.',
        Hindi: 'सीएसआर केवल दान या परोपकार नहीं है—यह कंपनी के संचालन और सामाजिक तथा पर्यावरणीय सरोकारों के समेकन की प्रक्रिया है। इसके माध्यम से कंपनियाँ समुदाय में सकारात्मक भूमिका निभा सकती हैं, विश्वास बना सकती हैं, ब्रांड की छवि सुधार सकती हैं और सतत विकास को बढ़ावा दे सकती हैं। भारत जैसे विकासशील देश में सीएसआर सरकारी प्रयासों को समर्थन देकर और क्रियान्वयन एजेंसियों एवं नागरिक संगठनों के साथ सीधे काम करके विकास की खाई को पाटने में भी मदद करता है.'
    },

    aboutFifth: {
        English: 'Overall, the CSR Portal of Bihar is a progressive step toward institutionalizing CSR practices in the state. It fosters stronger public-private partnerships and ensures that CSR contributions are directed toward areas of highest need. By leveraging technology, the portal enables a transparent, participatory, and results-driven ecosystem that supports Bihar’s broader development goals.',
        Hindi: 'कुल मिलाकर, बिहार का CSR पोर्टल राज्य में CSR प्रथाओं को संस्थागत बनाने की दिशा में एक प्रगतिशील कदम है। यह सार्वजनिक-निजी साझेदारी को सुदृढ़ करता है और यह सुनिश्चित करता है कि CSR योगदान सबसे अधिक आवश्यकता वाले क्षेत्रों में पहुंचे। प्रौद्योगिकी का उपयोग करते हुए, यह पोर्टल पारदर्शी, सहभागी और परिणामोन्मुखी प्रणाली को सक्षम बनाता है जो बिहार के व्यापक विकास लक्ष्यों का समर्थन करता है.'
    },

    CSRCommittee: {
        English: 'CSR Society',
        Hindi: 'सीएसआर सोसाइटी',
    },

    CommitteeFirst: {
        English: 'The Bihar State CSR Society was constituted under the chairmanship of the Chief Secretary to streamline and institutionalize CSR funding across the state. This Society will primarily act as a facilitator, enabler, or implementer for CSR Projects.The Governing Body of the Bihar State Corporate Social Responsibility (CSR) Society has been constituted as follows :-',
        Hindi: 'बिहार राज्य में सीएसआर निवेश को सुव्यवस्थित और संस्थागत बनाने के लिए मुख्य सचिव की अध्यक्षता में बिहार राज्य सीएसआर सोसाइटी का गठन किया गया.सीएसआर सोसाइटी मुख्य रूप से सीएसआर परियोजनाओं के सुविधाकर्ता, अनुमोदनकर्ता या कार्यान्वयनकर्ता की भूमिका निभाएगी. बिहार राज्य सामाजिक उत्तरदायित्व (सीएसआर) सोसायटी के शासी निकाय का गठन निम्न रूप में है :-'
    },

    commiteeObjective: {
        English: 'The objective of Bihar CSR Society will be: ', Hindi: 'कॉरपोरेट सामाजिक उत्तरदायित्व सोसाइटी के उद्देश्य :- '
    },

    commiteeObjectives: [
        {
            English: 'To ensure clarity in CSR-related arrangements in the state.', Hindi: 'राज्य में कॉरपोरेट  सामाजिक उत्तरदायित्व (CSR) से संबंधित व्यवस्था में आवश्यक स्पष्टता लाना।'
        },
        {
            English: 'Facilitate the development of rules, guidelines, and frameworks, as and when required, to strengthen the CSR ecosystem in the State.', Hindi: 'राज्य में सीएसआर (CSR) पारिस्थितिकी तंत्र को सशक्त बनाने हेतु आवश्यकतानुसार नियमों, दिशा-निर्देशों और रूपरेखाओं के विकास को सुगम बनाना।'
        },
        {
            English: 'To ensure mobilization and efficient utilization of CSR funds from PSUs/Corporates/individual donors.', Hindi: 'PSUs/कॉरपोरेट /व्यक्तिगत सेवा प्रदाता से कॉरपोरेट  सामाजिक उत्तरदायित्व (CSR) Fund के सृजन और कुशल उपयोग को सुनिश्चित करना।'
        },
        {
            English: 'To prepare a "Shelf of Projects" aligned with state development priorities and Schedule VII of the Companies Act, 2013. The Society will facilitate CSR Stakeholders to list selected projects on the states CSR portal.', Hindi: 'राज्य के विकास प्राथमिकताओं और कम्पनी अधिनियम 2013 की अनुसूची–VII के अनुरूप परियोजनाओं की सूची (Shelf of Projects) तैयार करना। सीएसआर हितधारकों को चयनित परियोजनाओं को राज्य के सीएसआर पोर्टल पर सुगमता पूर्वक देखने की सुविधा प्रदान करना।'
        },
        {
            English: 'To provide guidance in developing CSR proposals in line with the state’s priorities and simplify implementation through the "Shelf of Projects.', Hindi: 'राज्य की प्राथमिकताओं के अनुरूप CSR परियोजना प्रस्तावों के निर्माण में मार्ग दर्शन देना और Shelf of Project के माध्यम से कार्यान्वयन को सरल बनाना।'
        },
        {
            English: 'To promote innovative and sustainable practices to address socioeconomic and environmental challenges.', Hindi: 'सामाजिक–आर्थिक और पर्यावरणीय चुनौतियों के समाधान हेतु नवाचारी (Innovative) एवं सतत कार्य प्रणाली को प्रोत्साहित करना।'
        },
        {
            English: 'To strengthen collaboration among companies, government agencies, and NGOs', Hindi: 'राज्य में उल्लेखनीय CSR योगदान के लिए संस्थाओं एवं क्रियान्वयन एजेंसियों को सम्मानित/पुरस्कृत करना।'
        },
        {
            English: 'To recognize and incentivize key donors and NGO for exemplary CSR contributionsin the state.', Hindi: 'जिला स्तरीय CSR समिति का गठन करना एवं मार्ग दर्शन प्रदान करना।'
        },
    ],

    Disclaimer: {
        English: 'Disclaimer',
        Hindi: 'अस्वीकरण'
    },

    DisclaimerFirst: {
        English: 'The information provided on the Sri Siddhguru CSR Portal is for general informational purposes only. While efforts have been made to ensure the accuracy and reliability of the content, it should not be construed as legal advice or a commitment to undertake any project. Users are advised to exercise their own discretion and conduct due diligence before acting on any information available on this portal.',
        Hindi: 'सीएसआर बिहार पोर्टल पर दी गई जानकारी केवल सामान्य सूचना के उद्देश्यों के लिए है। यद्यपि सामग्री की सटीकता और विश्वसनीयता सुनिश्चित करने का प्रयास किया गया है, लेकिन इसे कानूनी सलाह या किसी परियोजना को क्रियान्वित करने की प्रतिबद्धता के रूप में नहीं लिया जाना चाहिए। उपयोगकर्ताओं को सलाह दी जाती है कि वे इस पोर्टल पर उपलब्ध किसी भी जानकारी पर कार्य करने से पहले स्वयं विवेक का प्रयोग करें और उचित जांच-पड़ताल करें.'
    },

    DisclaimerSecond: {
        English: 'The data available on the portal is as submitted by various stakeholders such as government departments, IA’s and donors. The finance Department, , does not verify the accuracy or authenticity of such data and shall not be held responsible for any discrepancies. No representation or warranty, express or implied, is given by the Department regarding the completeness, accuracy, or reliability of the content provided. No responsibility or liability shall be accepted any lose or damage that a user may suffer as a result of use of this portal.',
        Hindi: 'इस पोर्टल पर उपलब्ध डेटा विभिन्न हितधारकों जैसे कि सरकारी विभागों, कार्यान्वयन एजेंसियों (IA) और सेवा प्रदाता द्वारा प्रस्तुत किया गया है। वित्त विभाग, बिहार सरकार, इस डेटा की सटीकता या प्रामाणिकता की पुष्टि नहीं करता है और किसी भी त्रुटि या भिन्नता के लिए उत्तरदायी नहीं होगा। विभाग द्वारा प्रदान की गई सामग्री की पूर्णता, सटीकता या विश्वसनीयता को लेकर कोई प्रत्यक्ष या परोक्ष गारंटी नहीं दी जाती है। इस पोर्टल के उपयोग के कारण उपयोगकर्ता को होने वाले किसी भी प्रकार के नुकसान या क्षति के लिए कोई जिम्मेदारी या दायित्व स्वीकार नहीं किया जाएगा.',
    },

    SitePolicy: {
        English: 'Site Policy',
        Hindi: 'साइट नीति'
    },

    sitePolicyDecribe: {
        English: 'This website is designed, developed, and maintained by the finance Department, , to provide information and services related to Corporate Social Responsibility (CSR) activities in the state.',
        Hindi: 'यह वेबसाइट वित्त विभाग, बिहार सरकार द्वारा कॉरपोरेट सामाजिक उत्तरदायित्व (CSR) गतिविधियों से संबंधित जानकारी और सेवाएं प्रदान करने के लिए डिज़ाइन, विकसित और अनुरक्षित की गई है.'
    },

    sitePolicyTitle: [
        {
            English: 'Content Accuracy',
            Hindi: 'सामग्री की सटीकता'
        },
        {
            English: 'External Links',
            Hindi: 'बाहरी लिंक'
        },
        {
            English: 'Copyright Policy',
            Hindi: 'कॉपीराइट नीति'
        },
        {
            English: 'Privacy Policy',
            Hindi: 'गोपनीयता नीति'
        },
        {
            English: 'Website Security',
            Hindi: 'वेबसाइट सुरक्षा'
        },
        {
            English: 'Changes to Policy',
            Hindi: 'नीति में परिवर्तन'
        }
    ],

    sitePolicyDetails: [
        {
            English: 'The content on this site is based on information provided by various stakeholders. While every effort is made to ensure the accuracy and reliability of the data, the Department does not guarantee its completeness or correctness. Users are advised to independently verify any information before making decisions based on it.',
            Hindi: 'इस साइट की सामग्री विभिन्न हितधारकों द्वारा प्रदान की गई जानकारी पर आधारित है। यद्यपि डेटा की सटीकता और विश्वसनीयता सुनिश्चित करने का हर संभव प्रयास किया गया है, विभाग इसकी पूर्णता या शुद्धता की गारंटी नहीं देता। उपयोगकर्ताओं को सलाह दी जाती है कि किसी भी निर्णय से पहले स्वतंत्र रूप से जानकारी को सत्यापित करें.'
        },
        {
            English: 'This website may contain links to other websites or portals. These links are provided for user convenience only. The Department is not responsible for the content or reliability of linked websites and does not endorse the views expressed therein.',
            Hindi: 'इस वेबसाइट में अन्य वेबसाइटों या पोर्टलों के लिंक शामिल हो सकते हैं। ये लिंक केवल उपयोगकर्ता की सुविधा के लिए प्रदान किए गए हैं। विभाग लिंक की गई वेबसाइटों की सामग्री या विश्वसनीयता के लिए उत्तरदायी नहीं है और उनमें व्यक्त विचारों का समर्थन नहीं करता.'
        },
        {
            English: 'Unless stated otherwise, all content on this website is the property of the Department, . Users may reproduce the content without modifications for non-commercial purposes with due acknowledgment of the source.',
            Hindi: 'जब तक अन्यथा उल्लेख न किया गया हो, इस वेबसाइट की सभी सामग्री वित्त विभाग, बिहार सरकार की संपत्ति है। उपयोगकर्ता इस सामग्री को स्रोत का उचित उल्लेख करते हुए, बिना किसी परिवर्तन के, गैर-व्यावसायिक उद्देश्यों के लिए पुन: प्रस्तुत कर सकते हैं.'
        },
        {
            English: 'The portal respects the privacy of its users. Any personal information collected (if any) will be used solely for official purposes and will not be shared with unauthorized third parties.',
            Hindi: 'यह पोर्टल उपयोगकर्ताओं की गोपनीयता का सम्मान करता है। यदि कोई व्यक्तिगत जानकारी एकत्रित की जाती है, तो उसका उपयोग केवल आधिकारिक उद्देश्यों के लिए किया जाएगा और किसी भी अनधिकृत तृतीय पक्ष के साथ साझा नहीं किया जाएगा.'
        },
        {
            English: 'The site is monitored regularly to prevent unauthorized access and ensure data security. However, the Department is not liable for any loss or damage caused by system errors, viruses, or cyber-attacks beyond its control.',
            Hindi: 'इस साइट की नियमित रूप से निगरानी की जाती है ताकि अनधिकृत पहुंच को रोका जा सके और डेटा सुरक्षा सुनिश्चित की जा सके। हालांकि, विभाग ऐसी किसी प्रणाली त्रुटि, वायरस या साइबर हमले के कारण हुई हानि या क्षति के लिए उत्तरदायी नहीं होगा जो विभाग के नियंत्रण से बाहर हो.'
        },
        {
            English: 'The Department reserves the right to change or update this Site Policy without prior notice. Users are encouraged to check this page periodically for the latest version.',
            Hindi: 'विभाग बिना किसी पूर्व सूचना के इस साइट नीति में बदलाव या अद्यतन करने का अधिकार सुरक्षित रखता है। उपयोगकर्ताओं को नवीनतम संस्करण के लिए समय-समय पर इस पृष्ठ की जांच करने की सलाह दी जाती है.'
        }
    ],

    download: {
        English: "Download",
        Hindi: "डाउनलोड"
    },
    delete: {
        English: "Delete",
        Hindi: "हटाएं"
    },

    downloading: {
        English: "Downloading...",
        Hindi: "डाउनलोड हो रहा है..."
    },
    edit: {
        English: "Edit",
        Hindi: "संपादित करें"
    },
    permission: {
        English: "Permission",
        Hindi: "अनुमति"
    },
    view: {
        English: "View",
        Hindi: "देखें"
    },
    update: {
        English: "Update",
        Hindi: "अपडेट करें"

    },

    homePageSubTitle: {
        key: 'pagesubHead',
        value: 'pagesubHead',
        url: '/home',
        English: 'Service with Devotion – Sri Siddhguru',
        Hindi: 'भक्ति सहित सेवा – श्री सिद्धगुरु',
    },

    homePageButton: [
        {
            key: 'register',
            value: 'register',
            English: 'Register',
            Hindi: 'पंजीकरण',
        },
        {
            key: 'login',
            value: 'login',
            English: 'Login',
            Hindi: 'प्रवेश करें',
        }
    ],

    homePageMain: {
        English: "Home",
        Hindi: "मुख्य पृष्ठ"
    },

    RegisterDialog: {
        Title: {
            key: 'registerasa',
            value: 'registerasa',
            English: 'Register as A',
            Hindi: 'पंजीकरण करें',
        },
        DialogOptions: [
            {
                key: 'donor-registration',
                value: 'donor-registration',
                url: '/donor-registration',
                icon: 'Building2',
                accent: '#C8520A',
                btn: 'bg-[#C8520A] hover:bg-[#E8702A]',
                English: 'CSR Partner',
                Hindi: 'सीएसआर भागीदार',
            },
            {
                key: 'implementing-registration',
                value: 'implementing-registration',
                url: '/implementing-registration',
                icon: 'ClipboardList',
                accent: '#2D6A4F',
                btn: 'bg-[#2D6A4F] hover:bg-[#3B8266]',
                English: 'NGO',
                Hindi: 'गैर-सरकारी संगठन (एनजीओ)',
            },
            {
                key: 'sewa-volunteer',
                value: 'sewa-volunteer',
                url: '/sewa-volunteer',
                icon: 'HandHeart',
                accent: '#1565C0',
                btn: 'bg-[#1565C0] hover:bg-[#1976D2]',
                English: 'Volunteer',
                Hindi: 'सेवा स्वयंसेवक',
            },

        ],
        DialogFooter:
        {
            key: 'already-login',
            value: 'already-login',
            url: '/auth/login',
            English: 'Already a Member ?',
            Hindi: 'क्या पहले से ही सदस्य हैं ?',
        },

    },

    homePageLinks: [
        {
            key: 'home',
            value: 'home',
            url: '/home',
            icon: 'HomeIcon',
            English: 'Home',
            Hindi: 'मुख्य पृष्ठ',
        },
        {
            key: 'about-us',
            value: 'about-us',
            url: '/about-us',
            icon: 'InfoIcon',
            English: 'About Ashram',
            Hindi: 'आश्रम के बारे में',
        },
        // {
        //     key: 'donors',
        //     value: 'donors',
        //     url: '/donors',
        //     icon: 'BusinessIcon',
        //     English: 'Donors',
        //     Hindi: 'सेवा प्रदाता',
        // },
        // {
        //     key: 'implementing-agencies',
        //     value: 'implementing-agencies',
        //     url: '/implementing-agencies',
        //     icon: 'PartnersIcon',
        //     English: 'NGO',
        //     Hindi: 'क्रियान्वयन एजेंसियां',
        // },
        {
            key: 'projects',
            value: 'projects',
            url: '/projects-listing',
            icon: 'Project',
            English: 'Projects',
            Hindi: 'परियोजना',
        },
        // {
        //     key: 'news',
        //     value: 'news',
        //     url: '/news',
        //     icon: 'NewsIcon',
        //     English: 'News',
        //     Hindi: 'समाचार',
        // },
        // {
        //     key: 'events',
        //     value: 'events',
        //     url: '/events',
        //     icon: 'EventIcon',
        //     English: 'Events',
        //     Hindi: 'आयोजन',
        // },
        // {
        //     key: 'tenders',
        //     value: 'tenders',
        //     url: '/tenders',
        //     icon: 'EventIcon',
        //     English: 'Tenders',
        //     Hindi: 'निविदाएँ'
        // },
        // {
        //     key: 'help',
        //     value: 'help',
        //     url: '/help',
        //     icon: 'HelpIcon',
        //     English: 'Help',
        //     Hindi: 'सहायता',
        // }
    ],

    donor: {
        title: {
            English: 'Sewa Partner Registration',
            Hindi: 'सेवा प्रदाता पंजीकरण'
        },
        dropdown: {
            selected: {
                English: 'Select Sewa Partner Type',
                Hindi: 'सेवा प्रदाता प्रकार चुने '
            },
            companypsu: {
                English: 'Company/PSU',
                Hindi: 'कंपनी/पीएसयू'
            },
            noncompany: {
                English: 'Non-Company',
                Hindi: 'गैर-कंपनी'
            },
            individual: {
                English: 'Individual',
                Hindi: 'वैयक्तिक'
            },
            search: {
                English: "Enter to  Search",
                Hindi: "खोजने के लिए दर्ज करें"
            }
        },
    },


    implAgency: {
        title: {
            English: 'NGO Registration',
            Hindi: 'कार्यान्वयन एजेंसी पंजीकर'
        },
        dropdown: {
            selected: {
                English: 'Select NGO Type',
                Hindi: 'कार्यान्वयन एजेंसी प्रकार चुने '
            },
            section8: {
                English: 'Section-8 Company',
                Hindi: 'धारा-8 कंपनी'
            },
            societyTrust: {
                English: 'Society/Trust',
                Hindi: 'सोसाइटी / ट्रस्ट'
            },
            donorFound: {
                English: 'Sewa Partner Foundation',
                Hindi: 'सेवा प्रदाता फाउंडेशन'
            },
            autoBody: {
                English: 'Autonomous Body',
                Hindi: 'स्वायत्त निकाय'
            },
            search: {
                English: "Enter to Search",
                Hindi: "खोजने के लिए दर्ज करें"
            }
        },

    },

    steps: [
        { English: 'Corporate Information', Hindi: 'कॉरपोरेट की जानकारी' },
        { English: 'Organization Information', Hindi: 'संस्था की जानकारी' },
        { English: 'Department Information', Hindi: 'विभागीय जानकारी' },
        { English: 'Correspondence Information', Hindi: 'पत्राचार की जानकारी' },
        { English: 'Banking Details', Hindi: 'बैंक की  जानकारी' },
        { English: 'Financial Information', Hindi: 'वित्तीय की  जानकारी' },
        { English: 'CSR Funding Details', Hindi: 'सीएसआर निधि प्राप्त विवरण' },
        { English: 'Basic Information', Hindi: 'मूलभूत जानकारी' },
        { English: 'Document Upload', Hindi: 'दस्तावेज़ अपलोड' },
        { English: 'Submit Form', Hindi: 'फॉर्म जमा करें' }
    ],

    masters: {
        roleMaster: {
            mainTitle: {
                English: "Role Master",
                Hindi: "भूमिका मास्टर"
            },
            addRole: {
                English: "Add Role",
                Hindi: "भूमिका जोड़ें"
            },
            eidtRole: {
                English: "Edit Role",
                Hindi: "भूमिका संपादित करें"
            },
            roleDropdown: {
                role: {
                    English: "Role *",
                    Hindi: "भूमिका"
                },
                dropdownLabel: {
                    English: "Select Role Type",
                    Hindi: "भूमिका प्रकार चुनें"
                }
            }
        },
        SewaMaster: {
            mainTitle: {
                English: "Sewa Master",
                Hindi: "वर्कफ़्लो मास्टर"
            },
            sewaSearch: {
                English: "Search By Sewa",
                Hindi: "भूमिका द्वारा खोजें"
            },
            viewDocument: {
                English: "View Document",
                Hindi: "दस्तावेज़ देखें"
            },
            more: {
                English: "more",
                Hindi: "और"
            },
            addButton: {
                English: "Sewa",
                Hindi: "सेवा जोड़ें"
            },
            addDialogTitle: {
                English: "Add Sewa",
                Hindi: "सेवा जोड़ें"
            },
            updateDialogTitle: {
                English: "Update Sewa",
                Hindi: "सेवा अपडेट करें"
            },
            deleteDialogTitle: {
                English: "Delete Sewa",
                Hindi: "सेवा हटाएं"
            },
            deleteConfirmMessage: {
                English: "Are you sure you want to delete this Sewa?",
                Hindi: "क्या आप वाकई इस सेवा को हटाना चाहते हैं?"
            },
            headCells: {
                srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
                sewaName: { English: "Sewa Name", Hindi: "सेवा का नाम" },
                sewaDate: { English: "Sewa Date", Hindi: "सेवा तिथि" },
                description: { English: "Description", Hindi: "विवरण" },
                address: { English: "Address", Hindi: "पता" },
                documents: { English: "Documents", Hindi: "दस्तावेज़" },
                createdDate: { English: "Created Date", Hindi: "बनाई गई तिथि" },
                action: { English: "Action", Hindi: "कार्रवाई" },
            },
        },
        workFlowMaster: {
            mainTitle: {
                English: "Workflow Master",
                Hindi: "वर्कफ़्लो मास्टर"
            },
            moduleSelectDropDown: {
                English: "Select Module *",
                Hindi: "मॉड्यूल चुनें"
            },
            viewWorkflowDetails: {
                English: "View Workflow Details",
                Hindi: "वर्कफ़्लो विवरण देखें"
            }
        },
        menuMaster: {
            mainTitle: {
                English: "Menu Master",
                Hindi: "मेनू मास्टर"
            },
            addMenu: {
                English: "Add Menu",
                Hindi: "मेनू जोड़ें"
            },
            Search: {
                English: "Search By Name",
                Hindi: "नाम से खोजें"
            }
        }
    },

    registrations: {
        compliance: {
            English: "Compliance Pending",
            Hindi: "अनुपालन लंबित"
        },
        allUsers: {
            mainTitle: {
                English: "All Registered Users",
                Hindi: "सभी पंजीकृत उपयोगकर्ता"
            }
        },
        Donors: {
            mainTitle: {
                English: "Donors",
                Hindi: "सेवा प्रदाता"
            }
        },
        impAgency: {
            mainTitle: {
                English: "NGO",
                Hindi: "कार्यान्वयन एजेंसी"
            }
        },
        search: {
            English: "Search By Organization Name ",
            Hindi: "संगठन के नाम से खोजें"
        },
        govSearch: {
            English: "Search By User Name ",
            Hindi: "उपयोगकर्ता नाम से खोजें"
        },
        projectSearch: {
            English: "Search By Project Name",
            Hindi: "परियोजना नाम से खोजें"
        },
        agencySearch: {
            English: "Search By Agency Name",
            Hindi: "एजेंसी के नाम से खोजें"
        },
        roleSearch: {
            English: "Search By Role",
            Hindi: "भूमिका द्वारा खोजें"
        },
        masterSearch: {
            English: "Enter to Search by Module Name",
            Hindi: "मॉड्यूल नाम द्वारा खोजें"
        },
        Filter: {
            English: "Filter By Department",
            Hindi: "विभाग द्वारा फ़िल्टर करें"
        },
        commitmentFilter: {
            English: "Filter By Commitment",
            Hindi: "प्रतिबद्धता के अनुसार फ़िल्टर करें"
        },
        date: {
            startDate: {
                English: "Start Date",
                Hindi: "प्रारंभ तिथि"
            },
            endDate: {
                English: "End Date",
                Hindi: "समाप्ति तिथि"
            },
            toolTip: {
                selectStartDate: {
                    English: "Select Start Date",
                    Hindi: "प्रारंभ तिथि चुनें"
                },
                selectEndDate: {
                    English: "Select End Date",
                    Hindi: "समाप्ति तिथि चुनें"
                }
            }
        },
        button: {
            export: {
                English: "Export",
                Hindi: "निर्यात करें"
            },
            pending: {
                English: "Pending for Approval",
                Hindi: "मंज़ूरी के लिए लंबित"
            },
            reset: {
                English: "Reset",
                Hindi: "रीसेट करें"
            },
            createProject: {
                English: "Create Project",
                Hindi: "परियोजना बनाएँ"
            },
            updateProject: {
                English: "Update project",
                Hindi: "परियोजना अपडेट करें"
            },
            projectDetailsUpdate: {
                English: "Update Project Details",
                Hindi: "परियोजना विवरण अपडेट करें"
            },
            projectDetails: {
                English: "View Project in Details",
                Hindi: "परियोजना को विस्तार से देखें"
            },
            addRole: {
                English: "Add Role",
                Hindi: "भूमिका जोड़ें"
            },
            addSewa: {
                English: "Add Sewa",
                Hindi: "भूमिका जोड़ें"
            },
            addWorkFlow: {
                English: "Add Workflow",
                Hindi: "वर्कफ़्लो जोड़ें"
            },
            submit: {
                English: "Submit",
                Hindi: "जमा करें"
            },
            cancel: {
                English: "Cancel",
                Hindi: "रद्द करें"
            },
            update: {
                English: "Update",
                Hindi: "अपडेट करें"
            }
        },
        governmentUser: {
            mainTitle: {
                English: "Society Members",
                Hindi: "सोसाइटी सदस्य"
            }
        },
        csrProjects: {
            mainTitle: {
                English: "CSR Projects",
                Hindi: "सीएसआर परियोजनाएँ"
            },
        },
        completedProject: {
            mainTitle: {
                English: "Completed & Ongoing Projects",
                Hindi: "पूर्ण और चालू परियोजनाएँ"
            }
        },
        approvedProject: {
            mainTitle: {
                English: "Approved Projects",
                Hindi: "अनुमोदित परियोजनाएँ"
            }
        },
        myCommitmentProject: {
            mainTitle: {
                English: "My Commitment",
                Hindi: "मेरी प्रतिबद्धता"
            }
        },
        totalRecords: {
            English: "Total Records",
            Hindi: "कुल रिकॉर्ड"
        },
        allCommittedProject: {
            mainTitle: {
                English: "All Committed Project",
                Hindi: "सभी प्रतिबद्ध परियोजनाएँ"
            }
        },
        myProjects: {
            mainTitle: {
                English: "My Projects",
                Hindi: "मेरी परियोजनाएँ"
            },
        },
        myInterestedProject: {
            mainTitle: {
                English: "My Interested Projects",
                Hindi: "मेरी रुचिकर परियोजनाएँ"
            }
        },
        approvedAgencies: {
            mainTitle: {
                English: "Approved NGO",
                Hindi: "स्वीकृत एजेंसियाँ"
            }
        },
        mappingofIAProject: {
            mainTitle: {
                English: "Mapping of IA-Project",
                Hindi: "कार्यान्वयन एजेंसियों की परियोजनाओं का मानचित्रण"
            }
        },
        financialManagement: {
            fundDisburstment: {
                English: "Fund Disbursement & Utilized",
                Hindi: "धन वितरण एवं उपयोग"
            },
            financialManagementOverview: {
                English: "Financial Management Overview",
                Hindi: "वित्तीय प्रबंधन अवलोकन"
            }
        },
        UserDetails: {
            userName: { English: "User name", Hindi: "उपयोगकर्ता नाम" },
            name: { English: "Name", Hindi: "नाम" },
            state: { English: "State", Hindi: "राज्य" },
            district: { English: "District", Hindi: "जिला" },
            status: { English: "Status", Hindi: "स्थिति" },
            pending: { English: "Pending", Hindi: "लंबित" },
            approved: { English: "Approved", Hindi: "स्वीकृत" },
            rejectionReasonPlaceholder: { English: "Enter Rejection Reason.*", Hindi: "अस्वीकृति कारण दर्ज करें.*" },
            profile: {
                English: "Profile",
                Hindi: "प्रोफ़ाइल"
            },
            userType: {
                English: "User Type",
                Hindi: "उपयोगकर्ता प्रकार"
            },
            subType: {
                English: "Sub Type",
                Hindi: "उप-प्रकार"
            },
            applicationNumber: {
                English: "Application Number",
                Hindi: "आवेदन संख्या"
            },
            applicationDate: {
                English: "Application Date",
                Hindi: "आवेदन तिथि"
            }
        },
        noPendingApproval: {
            English: "No pending approvals found.",
            Hindi: "कोई लंबित अनुमोदन नहीं मिला।"
        }
    },
    tender: {
        mainTitle: {
            English: "Tender List",
            Hindi: "निविदा सूची"
        },
        clearFilter: {
            English: "Clear filter",
            Hindi: "फ़िल्टर हटाएं"
        },
        tabs: {
            tab1: {
                English: "Latest Tenders",
                Hindi: "नवीनतम निविदाएँ"
            },
            tab2: {
                English: "Latest Cancelled Tenders",
                Hindi: "नवीनतम रद्द की गई निविदाएँ"
            },
            tab3: {
                English: "Tenders with Corrigendum",
                Hindi: "संशोधित निविदाएँ"
            },
            tab4: {
                English: "Upcoming Tenders",
                Hindi: "आगामी निविदाएँ"
            },
            tab5: {
                English: "Past Tenders",
                Hindi: "पूर्व की निविदाएँ"
            },
        },
        button: {
            createTender: {
                English: "Create Tender",
                Hindi: "निविदा बनाएं"
            }
        }
    },

    knowledgeBase: {
        mainTitle: {
            English: "CSR Document Repository",
            Hindi: "सीएसआर दस्तावेज़ भंडार"
        },
        search: {
            English: "Enter to Search",
            Hindi: "खोजने के लिए दर्ज करें"
        },
        dropdown: {
            English: "Filter By Category",
            Hindi: "श्रेणी के अनुसार फ़िल्टर करें"
        },
        document: {
            English: "Documents",
            Hindi: "दस्तावेज़"
        },
        upload: {
            English: "Upload",
            Hindi: "अपलोड करें"
        },
        gridView: {
            English: "Grid View",
            Hindi: "ग्रिड दृश्य"
        },
        tableView: {
            English: "Table View",
            Hindi: "तालिका दृश्य"
        },
        activityDetails: {
            English: "Activity Details",
            Hindi: "गतिविधि विवरण"
        }

    },

    eventMedia: {
        mainTitle: {
            English: "Event and Media Management",
            Hindi: "कार्यक्रम और मीडिया प्रबंधन"
        },
        event: {
            English: "Event",
            Hindi: "कार्यक्रम जोड़ें "
        },
        mediaGallary: {
            English: "MEDIA GALLERY",
            Hindi: "मीडिया गैलरी"
        },
        search: {
            English: "Enter to Search",
            Hindi: "खोजने के लिए दर्ज करें"
        },
        upload: {
            English: "Upload",
            Hindi: "अपलोड करें"
        },
        pastEvent: {
            English: "Past Events",
            Hindi: "पूर्व आयोजन"
        },
        upcomingEvents: {
            English: "Upcoming Events",
            Hindi: "आगामी आयोजन"
        },
        detail: {
            English: "Details",
            Hindi: "विवरण"
        },
        delete: {
            English: "Delete",
            Hindi: "हटाएं"
        },
        register: {
            English: "Register",
            Hindi: "पंजीकरण करें"
        },
        publish: {
            English: "Publish",
            Hindi: "प्रकाशित करें"
        },
        eventDetail: {
            English: "Event Details",
            Hindi: "कार्यक्रम विवरण"
        },
        Agenda: {
            English: "Agenda",
            Hindi: "कार्यसूची"
        },
        date: {
            start: {
                English: "Start Date ",
                Hindi: "प्रारंभ तिथि *"
            },
            end: {
                English: "End date ",
                Hindi: "समाप्ति तिथि "
            }
        },
        time: {
            start: {
                English: "Start Time ",
                Hindi: "प्रारंभ समय "
            },
            end: {
                English: "End Time ",
                Hindi: "समाप्ति समय "
            }
        },
        description: {
            English: " Description ",
            Hindi: "विवरण "
        },
        location: {
            English: "Location",
            Hindi: "स्थान"
        },
        registeredUsers: {
            English: "Registered Users",
            Hindi: "पंजीकृत उपयोगकर्ता"
        },
        noImagesAvailable: {
            English: "No images available for this event.",
            Hindi: "इस कार्यक्रम के लिए कोई फ़ोटो उपलब्ध नहीं है।"
        }

    },
    eventForm: {
        mainTitle: {
            English: "Add Upcoming Event",
            Hindi: "आगामी कार्यक्रम जोड़ें"
        },
        eventTitle: {
            English: "Event Title ",
            Hindi: "कार्यक्रम का शीर्षक "
        },
        date: {
            start: {
                English: "Start Date",
                Hindi: "प्रारंभ तिथि"
            },
            end: {
                English: "End date ",
                Hindi: "समाप्ति तिथि "
            }
        },
        time: {
            start: {
                English: "Start Time ",
                Hindi: "प्रारंभ समय "
            },
            end: {
                English: "End Time ",
                Hindi: "समाप्ति समय "
            }
        },
        agenda: {
            English: "Select Event Agenda ",
            Hindi: "कार्यक्रम एजेंडा चुनें "
        },
        description: {
            English: "Event Description ",
            Hindi: "कार्यक्रम का विवरण "
        },
        address: {
            English: "Event Address ",
            Hindi: "कार्यक्रम का पता "
        },
        location: {
            English: "Location ",
            Hindi: "स्थान "
        },
        remove: {
            English: "Remove",
            Hindi: "हटाएं"
        },
        addEvent: {
            English: "Add Event",
            Hindi: "कार्यक्रम जोड़ें"
        },
    },

    dashboard: {
        title1: {
            English: "Registered Users Overview",
            Hindi: "पंजीकृत उपयोगकर्ता का अवलोकन"
        },
        title2: {
            English: "CSR Projects Overview",
            Hindi: "सीएसआर परियोजनाओं का अवलोकन"
        },
        title3: {
            English: "NGO Overview",
            Hindi: "कार्यान्वयन एजेंसियों का अवलोकन"
        },
        titile4: {
            English: "Financials Management Overview",
            Hindi: "वित्तीय प्रबंधन का अवलोकन"
        },
        heroTitle: {
            English: "Dashboard Overview",
            Hindi: "डैशबोर्ड का अवलोकन"
        }
    },

    dialogues: {
        delete: {
            quation: {
                English: "Want to Delete!",
                Hindi: "हटाना चाहते हैं!"
            },
            permenantPermision: {
                English: "this Document permanently?",
                Hindi: "इस दस्तावेज़ को स्थायी रूप से?"
            },
        },
        field: {
            English: "Enter document Delete Comment *",
            Hindi: "दस्तावेज़ हटाने की टिप्पणी दर्ज करें *"
        },
        button: {
            English: "Delete",
            Hindi: "हटाएं"
        },

        assignAgencyDialogue: [
            { English: "Minimum 1 unit required", Hindi: "कम से कम 1 इकाई आवश्यक है" },
            { English: "Cost per unit must be positive", Hindi: "प्रति इकाई लागत सकारात्मक होनी चाहिए" },
            { English: "This field is required", Hindi: "यह फ़ील्ड आवश्यक है" },
            { English: "Amount is required", Hindi: "राशि आवश्यक है" },
            { English: "Comment is required", Hindi: "टिप्पणी आवश्यक है" },
            { English: "Project Name", Hindi: "परियोजना का नाम" },
            { English: "No. of Units Committed", Hindi: "प्रतिबद्ध इकाइयों की संख्या" },
            { English: "Cost per Unit", Hindi: "प्रति इकाई लागत" },
            { English: "Total Commitment", Hindi: "कुल प्रतिबद्धता" },
            { English: "NGO", Hindi: "कार्यान्वयन एजेंसी" },
            { English: "Mode of Implementation *", Hindi: "कार्यान्वयन का तरीका *" },
            { English: "Select NGO *", Hindi: "कार्यान्वयन एजेंसी चुनें *" },
            { English: "Allocation Amount (₹) *", Hindi: "आवंटन राशि (₹) *" },
            { English: "Enter Comments", Hindi: "टिप्पणियाँ दर्ज करें" },
            { English: "Agency", Hindi: "एजेंसी" },
            { English: "Assign", Hindi: "सौंपें" }
        ],
        rejectCommitDialogue: [
            { English: "This field is required", Hindi: "यह फ़ील्ड आवश्यक है" },
            { English: "Minimum 1 unit required", Hindi: "कम से कम 1 इकाई आवश्यक है" },
            { English: "Cost per unit must be positive", Hindi: "प्रति इकाई लागत सकारात्मक होनी चाहिए" },
            { English: "Comment is required.!", Hindi: "टिप्पणी आवश्यक है.!" },
            { English: "Status updated successfully!", Hindi: "स्थिति सफलतापूर्वक अपडेट की गई!" },
            { English: "Failed to update status", Hindi: "स्थिति अपडेट करने में विफल" },
            { English: "No. of Units Committed", Hindi: "प्रतिबद्ध इकाइयों की संख्या" },
            { English: "Cost per Unit", Hindi: "प्रति इकाई लागत" },
            { English: "Total Commitment", Hindi: "कुल प्रतिबद्धता" },
            { English: "Enter Comments", Hindi: "टिप्पणियाँ दर्ज करें" }

        ],
        commitmenDialogue: [
            { English: "No. of Units Committed", Hindi: "प्रतिबद्ध इकाइयों की संख्या" },
            { English: "Cost per Unit", Hindi: "प्रति इकाई लागत" },
            { English: "Total Commitment", Hindi: "कुल प्रतिबद्धता" },
            { English: "Submit", Hindi: "जमा करें" }
        ],
        fundDisburstment: [
            { English: "Fund Disbursement", Hindi: "निधि वितरण" },
            { English: "Project Name", Hindi: "परियोजना का नाम" },
            { English: "NGO Name", Hindi: "कार्यान्वयन एजेंसी का नाम" },
            { English: "Disbursement Date", Hindi: "वितरण तिथि" },
            { English: "Disbursement Amount", Hindi: "वितरण राशि" },
            { English: "Amount is required", Hindi: "राशि आवश्यक है" },
            { English: "UTR No", Hindi: "यूटीआर संख्या" },
            { English: "Upload Attachment", Hindi: "अपलोड संलग्नक" },
            { English: "Mode of Payment", Hindi: "भुगतान का तरीका" },
            { English: "Enter Remarks", Hindi: "टिप्पणियाँ दर्ज करें" },
            { English: "Disburse", Hindi: "वितरित करें" }
        ],
        fundUtilised: [
            { English: "Project Name", Hindi: "परियोजना का नाम" },
            { English: "NGO", Hindi: "कार्यान्वयन एजेंसी" },
            { English: "Utilization Date", Hindi: "उपयोग की तिथि" },
            { English: "Utilized Amount", Hindi: "उपयोग की गई राशि" },
            { English: "Utilization Type", Hindi: "उपयोग का प्रकार" },
            { English: "Enter Remarks", Hindi: "टिप्पणियाँ दर्ज करें" },
            { English: "Upload Utilization Document", Hindi: "उपयोग दस्तावेज़ अपलोड करें" }

        ]



    },

    logIn: {
        BankDetails: {
            accountHold: {
                English: "Account Holder",
                Hindi: "खाता धारक"
            },
            accountNum: {
                English: "Account Number",
                Hindi: "खाता संख्या"
            },
            ifsc: {
                English: "IFSC Code",
                Hindi: "आईएफएससी कोड"
            },
            accountProofLabel: {
                English: "Account Proof",
                Hindi: "खाते का प्रमाण"
            },
            defaultAccountLabel: {
                English: "Default Account",
                Hindi: "डिफ़ॉल्ट खाता"
            },
            attachmentLabel: {
                English: "Attachment",
                Hindi: "संलग्नक"
            },

        },
        buttonLabels: {
            View: {
                English: "View",
                Hindi: "देखें"
            },
            Download: {
                English: "Download",
                Hindi: "डाउनलोड"
            },
            details: {
                English: "Details",
                Hindi: "विवरण"
            }
        }
    },

    forms: {
        typeofcompany: {
            dropDown: {
                private: {
                    English: 'Private',
                    Hindi: 'निजी'
                },
                public: {
                    English: 'Public',
                    Hindi: 'सार्वजनिक'
                },
                centralPsu: {
                    English: 'Central PSU',
                    Hindi: 'केंद्रीय पीएसयू'
                },
                statePsu: {
                    English: 'State PSU',
                    Hindi: 'राज्य पीएसयू'
                }
            },
            label: {
                English: 'Type of Company',
                Hindi: 'कंपनी के प्रकार'
            },
            reqerror: {
                English: 'Type of Company Required.',
                Hindi: 'कंपनी का प्रकार आवश्यक चुनें.'
            },
        },
        typeoforganisation: {
            dropdown: {
                partnership: {
                    English: "Partnership",
                    Hindi: "साझेदारी"
                },
                proprietorship: {
                    English: "Proprietorship",
                    Hindi: "स्वामित्व"
                },
                "society/Trust": {
                    English: "Society/Trust ",
                    Hindi: "समिति/ट्रस्ट"
                }
            },

        },
        name: {
            label: {
                English: 'Name',
                Hindi: 'नाम'
            },
            reqerror: {
                English: 'Name Required.',
                Hindi: 'नाम आवश्यक चुनें.'
            },
        },
        aadharNo: {
            label: {
                English: 'Aadhar Number',
                Hindi: 'आधार क्रमांक '
            },
            reqerror: {
                English: 'Aadhar Number Required.',
                Hindi: 'आधार क्रमांक आवश्यक चुनें.'
            },
        },
        aadharCard: {
            label: {
                English: 'Aadhar Card',
                Hindi: 'आधार कार्ड '
            },
            reqerror: {
                English: 'Aadhar Card Required.',
                Hindi: 'आधार कार्ड आवश्यक.'
            },
        },
        address: {
            label: {
                English: 'Register Address',
                Hindi: 'पंजीकृत पता'
            },
            reqerror: {
                English: 'Address is Required.',
                Hindi: 'पता आवश्यक चुनें.'
            },
        },
        typeofOrg: {
            label: {
                English: 'Type of Organization',
                Hindi: 'संस्था के प्रकार'
            },
            reqerror: {
                English: 'Type of Organization Required.',
                Hindi: 'संस्था का प्रकार आवश्यक चुनें.'
            },
        },
        orgName: {
            label: {
                English: 'Organisation Name',
                Hindi: 'संस्था का नाम'
            },
            reqerror: {
                English: 'Organisation Name Required.',
                Hindi: 'संस्था का नाम आवश्यक चुनें.'
            },
        },
        cin: {
            label: {
                English: 'CIN',
                Hindi: 'सीआईएन'
            },
            reqerror: {
                English: 'CIN is Required.',
                Hindi: 'सीआईएन आवश्यक है।'
            },
            formaterror: {
                English: 'Invalid CIN format. Ex: U12345MH2023PTC123456',
                Hindi: 'अमान्य CIN प्रारूप. जैसे: U12345MH2023PTC123456'
            },
        },
        nameofDept: {
            label: {
                English: 'Name of Department',
                Hindi: 'विभाग का नाम'
            },
            reqerror: {
                English: 'CIN is Required.',
                Hindi: 'सीआईएन आवश्यक है।'
            },
        },
        csr1Cert: {
            label: {
                English: 'CSR-1 Certificate Number',
                Hindi: 'सीएसआर-1 प्रमाणपत्र संख्या'
            },
            reqerror: {
                English: "CSR-1 Certificate Number is required",
                Hindi: "सीएसआर-1 प्रमाणपत्र संख्या अनिवार्य है"
            },
            certificateUpload: {
                label: {
                    English: "Upload CSR-1 Certificate",
                    Hindi: "सीएसआर-1 प्रमाणपत्र अपलोड करें"
                },
                reqError: {
                    English: "Please upload your CSR-1 Certificate",
                    Hindi: "कृपया अपना सीएसआर-1 प्रमाणपत्र अपलोड करें"
                }
            }
        },
        darpanCert: {
            label: {
                English: 'Darpan Registration Number',
                Hindi: 'दर्पण पंजीकरण संख्या'
            },
            reqerror: {
                English: "Darpan Registration Number is required",
                Hindi: "दर्पण पंजीकरण संख्या अनिवार्य है"
            },
        },
        organisationName: {
            label: {
                English: 'Organisation Name',
                Hindi: 'संगठन का नाम'
            },
            reqerror: {
                English: 'Organisation Name is Required.',
                Hindi: 'संगठन का नाम आवश्यक है।'
            },
        },
        sector: {
            label: {
                English: 'Sector',
                Hindi: 'क्षेत्र'
            },
            reqerror: {
                English: 'sector Name is Required.',
                Hindi: 'क्षेत्र का नाम आवश्यक है।'
            },
        },
        website: {
            label: {
                English: 'Website',
                Hindi: 'वेबसाइट'
            },
            reqerror: {
                English: 'Website is Required.',
                Hindi: 'वेबसाइट आवश्यक है।'
            },

        },
        csrProjects: {
            title: {
                English: 'CSR Projects',
                Hindi: 'सीएसआर परियोजनाएँ'
            },
            button: {
                English: 'Project',
                Hindi: 'परियोजना'
            },
            dropdown: {
                English: "Filter By Department",
                Hindi: "विभाग द्वारा फ़िल्टर करे"
            },
            search: {
                English: "Enter to Search",
                Hindi: "खोजने के लिए दर्ज करें"
            },
            forms: {
                projectName: {
                    label: {
                        English: 'Project Name',
                        Hindi: 'परियोजना का नाम'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Hindi: 'संगठन का नाम आवश्यक है।'
                    },
                },
                finYear: {
                    label: {
                        English: 'Financial Year',
                        Hindi: 'वित्तीय वर्ष'
                    },
                    reqerror: {
                        English: 'Financial Year is Required.',
                        Hindi: 'वित्तीय वर्ष आवश्यक है।'
                    },
                },
                donName: {
                    label: {
                        English: 'Sewa Partner Name',
                        Hindi: 'सेवा प्रदाता का नाम'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Hindi: 'संगठन का नाम आवश्यक है।'
                    },
                },
                consPerson: {
                    label: {
                        English: 'Concerned Person',
                        Hindi: 'संबंधित व्यक्ति'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Hindi: 'संगठन का नाम आवश्यक है।'
                    },
                },
                amount: {
                    label: {
                        English: 'Amount',
                        Hindi: 'राशि'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Hindi: 'संगठन का नाम आवश्यक है।'
                    },
                },
                status: {
                    label: {
                        English: 'Status',
                        Hindi: 'स्थिति'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Hindi: 'संगठन का नाम आवश्यक है।'
                    },
                },
                projectDesc: {
                    label: {
                        English: 'Project Description',
                        Hindi: 'परियोजना विवरण'
                    },
                    reqerror: {
                        English: 'Organisation Name is Required.',
                        Hindi: 'संगठन का नाम आवश्यक है।'
                    },
                },

            }
        },
        email: {
            label: {
                English: 'Email',
                Hindi: 'ईमेल'
            },
            placeHolder: {
                English: "Enter your email",
                Hindi: "अपना ईमेल दर्ज करें"
            },
            reset: {
                English: "Send reset link",
                Hindi: "रीसेट लिंक भेजें"
            },
            reqerror: {
                English: 'Mail Id is Required.',
                Hindi: 'ईमेल आईडी आवश्यक है।'
            },
            validerror: {
                English: 'Enter Valid Mail Id.',
                Hindi: 'वैध ईमेल आईडी दर्ज करें।'
            },
        },
        Mailotp: {
            label: {
                English: 'Mail OTP',
                Hindi: 'ईमेल ओ.टी.पी'
            },
            enterMail: {
                English: "Enter OTP",
                Hindi: "ओटीपी दर्ज करें"
            },
            otpSentOn: {
                English: "OTP Sent On",
                Hindi: "ओटीपी इस पर भेजा गया:"
            },
            sendOtp: {
                English: "Send OTP",
                Hindi: "ओटीपी भेजें"
            },
            sendOtpToMail: {
                English: "Send OTP",
                Hindi: "ओटीपी भेजें",
            },
            resendOtp: {
                English: "Resend OTP",
                Hindi: "ओटीपी दोबारा भेजें"
            },
            verifyMailOtp: {
                English: "Verify OTP",
                Hindi: "ओटीपी सत्यापित करें",
            },
            otpSentOnMail: {
                English: "OTP Sent on Registered Mail!",
                Hindi: "आपके पंजीकृत ईमेल पर ओटीपी भेज दिया गया है!"
            },
            verified: {
                English: "Verified",
                Hindi: "सत्यापित"
            },
            mailVerified: {
                English: "Mail Verified",
                Hindi: "मेल सत्यापित"
            },
            submitOtp: {
                English: "Submit OTP",
                Hindi: "ओटीपी जमा करें",
            },
            reqerror: {
                English: 'Mail OTP is Required.',
                Hindi: 'ईमेल ओ.टी.पी आवश्यक है।'
            },
            wrongotpTitle: {
                English: 'Wrong OTP.',
                Hindi: 'गलत ओ.टी.पी।'
            },
            wrongotpbody: {
                English: 'Too many attempts. Please try again after some time.',
                Hindi: 'बहुत बार प्रयास किया गया है। कृपया कुछ समय बाद पुनः प्रयास करें।'
            },
            validerror: {
                English: 'Enter Valid Mail OTP.',
                Hindi: 'वैध ईमेल ओ.टी.पी दर्ज करें।'
            },
            FYYear: {
                label: {
                    English: "Financial Year",
                    Hindi: "विव वर्ष "
                },
            },
            invalidUrl: {
                English: "Invalid URL",
                Hindi: "अमान्य लिंक"
            }
        },
        mobile: {
            label: {
                English: 'Mobile Number',
                Hindi: 'मोबाइल नंबर'
            },
            reqerror: {
                English: 'Mobile Number is Required.',
                Hindi: 'मोबाइल नंबर आवश्यक है।'
            },
            validerror: {
                English: 'Please enter a valid number.',
                Hindi: 'कृपया एक मान्य नंबर दर्ज करें।'
            },
        },
        gst: {
            label: {
                English: 'GST Number',
                Hindi: 'जीएसटी नंबर'
            },
            reqerror: {
                English: 'GST No. Required.',
                Hindi: 'जीएसटी नंबर आवश्यक है।'
            },
            validerror: {
                English: 'Please enter a valid GST number.',
                Hindi: 'कृपया एक मान्य जीएसटी नंबर दर्ज करें।'
            },
        },
        pan: {
            label: {
                English: 'PAN Number',
                Hindi: 'पैन नंबर'
            },
            reqerror: {
                English: 'PAN Number is Required.',
                Hindi: 'पैन नंबर आवश्यक है।'
            },
            validerror: {
                English: 'Please Enter Valid PAN Number.',
                Hindi: 'कृपया वैध पैन नंबर दर्ज करें।'
            },
        },
        csrRegNo: {
            label: {
                English: 'CSR-1 Certificate Number',
                Hindi: 'सीएसआर-1 प्रमाणपत्र संख्या'
            },
            reqerror: {
                English: 'CSR-1 Certificate Number is Required.',
                Hindi: 'सीएसआर-1 प्रमाणपत्र संख्या आवश्यक है।.'
            },
            validerror: {
                English: 'CSR-1 Certificate Number.',
                Hindi: 'कृपया वैध सीएसआर-1 प्रमाणपत्र संख्या दर्ज करें।'
            },
        },
        darpanRegNo: {
            label: {
                English: 'Darpan Registration Number',
                Hindi: 'दर्पण पंजीकरण संख्या'
            },
            reqerror: {
                English: 'Darpan Registration Number is Required.',
                Hindi: 'दर्पण पंजीकरण संख्या आवश्यक है।.'
            },
            validerror: {
                English: 'Enter Valid Darpan Registration Number',
                Hindi: 'कृपया वैध दर्पण पंजीकरण संख्या दर्ज करें।'
            },
        },
        dateOfInc: {
            label: {
                English: 'Date of Incorporation',
                Hindi: 'निगमन की तारीख'
            },
            reqerror: {
                English: 'Date Of Incorporation Required.',
                Hindi: 'निगमन की तारीख आवश्यक है।'
            },
        },
        registerAdd: {
            label: {
                English: 'Registered Address',
                Hindi: 'पंजीकृत पता'
            },
            reqerror: {
                English: 'Registered Address is Required.',
                Hindi: 'पंजीकृत पता आवश्यक है।'
            },
        },
        pinCode: {
            label: {
                English: 'Pin Code',
                Hindi: 'पिन कोड'
            },
            reqerror: {
                English: 'Pin Code is Required.',
                Hindi: 'पिन कोड आवश्यक है।'
            },
            validerror: {
                English: 'Please enter a valid Pin Code.',
                Hindi: 'कृपया एक मान्य पिन कोड दर्ज करें।'
            },
        },

        Bank: {
            name: {
                label: {
                    English: "Bank Name *",
                    Hindi: "बैंक का नाम *"
                },
                reqError: {
                    English: "Bank Name is required",
                    Hindi: "बैंक का नाम अनिवार्य है"
                }
            },


            accountNumber: {
                label: {
                    English: "Account Number *",
                    Hindi: "खाता संख्या *"
                },
                reqError: {
                    English: "Account Number is required",
                    Hindi: "खाता संख्या अनिवार्य है "
                },
                accountNumberMinLength: {
                    English: "Account number must be at least 9 digits",
                    Hindi: "खाता संख्या कम से कम 9 अंकों की होनी चाहिए"
                },
                accountNumberMaxLength: {
                    English: "Account number must be at most 15 digits",
                    Hindi: "खाता संख्या अधिकतम 15 अंकों की होनी चाहिए"
                },
                matches: {
                    English: "Only digits are allowed",
                    Hindi: "केवल अंक ही मान्य हैं"
                }
            },

            ifscCode: {
                label: {
                    English: "IFSC Code *",
                    Hindi: "आईएफएससी कोड *"
                },
                reqError: {
                    English: "IFSC Code is required",
                    Hindi: "आईएफएससी कोड अनिवार्य है"
                },
                ifscCodeInvalid: {
                    English: "Enter a valid IFSC Code",
                    Hindi: "सही आईएफएससी कोड दर्ज करें"
                }
            },
            accountHolderName: {
                label: {
                    English: "Account Holder Name *",
                    Hindi: "खाताधारक का नाम *"
                },
                reqError: {
                    English: "Account Holder Name is required",
                    Hindi: "खाताधारक का नाम अनिवार्य है"
                },
                matches: {

                }
            },
            attachment: {
                label: {
                    English: "Attachment *",
                    Hindi: "बैंक प्रमाणपत्र *"
                },
                reqError: {
                    English: "Bank Proof is required",
                    Hindi: "बैंक प्रमाणपत्र अनिवार्य है"
                }
            },
            defaultOption: {
                English: "Default",
                Hindi: "डिफ़ॉल्ट चुनें"
            },
            addBank: {
                English: "+ Add Bank",
                Hindi: "+ बैंक जोड़ें"
            },
            year: {
                English: "Years",
                Hindi: "वर्ष"
            },
        },

        // financialData:{
        //     turnover: {
        //         English: "Turnover",
        //         Hindi: "टर्नओवर"
        //     },
        //     reqError: {
        //         English: "Turnover is required",
        //         Hindi: "टर्नओवर अनिवार्य है"
        //     }
        // },

        // profitLoss: {
        //     label: {
        //         English: "Profit / Loss",
        //         Hindi: "लाभ / हानि"
        //     },
        //     reqError: {
        //         English: "Profit / Loss is required",
        //         Hindi: "लाभ / हानि अनिवार्य है"
        //     }
        // },

        authorityLetter: {
            label: {
                English: 'Upload Authority Letter',
                Hindi: 'प्राधिकार पत्र अपलोड करें'
            },
            reqerror: {
                English: ' Authority Letter  is Required',
                Hindi: 'प्राधिकार पत्र आवश्यक है'
            }
        },
        uploadPanCard: {
            label: {
                English: "Upload PAN Card",
                Hindi: "पैन कार्ड जमा करें"
            },
            reqError: {
                English: "Please upload your PAN Card",
                Hindi: "कृपया अपना पैन कार्ड अपलोड करें"
            }
        },
        uploadCertificateOfIncrop: {
            label: {
                English: "Upload Incorporation Certificate",
                Hindi: "संस्थापन प्रमाणपत्र जमा करें"
            },
            reqError: {
                English: "Please upload your Certificate of Incorporation",
                Hindi: "कृपया अपना संस्थापन प्रमाणपत्र अपलोड करें"
            }
        },
        uploadGstCertf: {
            label: {
                English: "Upload GSTIN Certificate",
                Hindi: "जीएसटीआईएन प्रमाणपत्र जमा करें"
            },
            reqError: {
                English: "Please upload your GSTIN Certificate",
                Hindi: "कृपया अपना जीएसटीआईएन प्रमाणपत्र अपलोड करें"
            }
        },
        upload80gCertificate: {
            label: {
                English: "Upload 80G Certificate",
                Hindi: "80जी प्रमाणपत्र अपलोड करें"
            },
            reqError: {
                English: "Please upload your 80G Certificate",
                Hindi: "कृपया अपना 80जी प्रमाणपत्र अपलोड करें"
            }
        },

        uploadCsr1Certificate: {
            label: {
                English: "Upload CSR-1 Certificate",
                Hindi: "सीएसआर-1 प्रमाणपत्र अपलोड करें"
            },
            reqError: {
                English: "Please upload your CSR-1 Certificate",
                Hindi: "कृपया अपना सीएसआर-1 प्रमाणपत्र अपलोड करें"
            }
        },
        fileSizeLimit: {
            English: "File size must be less than 5MB",
            Hindi: "फ़ाइल का आकार 5MB से कम होना चाहिए"
        },
        stateName: {
            label: {
                English: 'State Name',
                Hindi: 'राज्य का नाम'
            },
            reqerror: {
                English: 'State Name is Required.',
                Hindi: 'राज्य का नाम आवश्यक है।'
            },
        },
        districtName: {
            label: {
                English: 'District Name',
                Hindi: 'जिले का नाम'
            },
            reqerror: {
                English: 'District Name is Required.',
                Hindi: 'जिले का नाम आवश्यक है।'
            },
        },
        companyweb: {
            label: {
                English: 'Company Website',
                Hindi: 'कंपनी वेबसाइट'
            },
        },
        contactPerson: {
            label: {
                English: "Name of Contact Person",
                Hindi: "संपर्क व्यक्ति का नाम"
            },
            reqerror: {
                English: "Contact Person Name is Required.",
                Hindi: "संपर्क व्यक्ति का नाम आवश्यक है।"
            }
        },

        designation: {
            label: {
                English: "Designation",
                Hindi: "पद का नाम"
            },
            reqerror: {
                English: "Designation is Required.",
                Hindi: "पद का नाम आवश्यक है।"
            }
        },
        financialYear: {
            label: {
                English: 'Financial Year',
                Hindi: 'वित्तीय वर्ष'
            }
        },
        turnOver: {
            label: {
                English: 'Turnover',
                Hindi: 'वार्षिक कारोबार'
            },
            reqerror: {
                English: "Turnover is Required.",
                Hindi: "वार्षिक कारोबार आवश्यक है"
            }
        },
        profitLoss: {
            label: {
                English: 'Profit and Loss',
                Hindi: 'लाभ और हानि'
            },
            reqerror: {
                English: "Profit and Loss is Required.",
                Hindi: "लाभ और हानि आवश्यक है"
            }
        },
        csrSpends: {
            label: {
                English: 'CSR Spent',
                Hindi: 'सीएसआर  खर्च'
            },
            reqerror: {
                English: "CSR Spent is Required.",
                Hindi: "सीएसआर  खर्च आवश्यक है"
            }
        },
        uploadStatement: {
            label: {
                English: "Upload Statement *",
                Hindi: "स्टेटमेंट अपलोड करें *"
            },
            reqError: {
                English: "Please upload the statement",
                Hindi: "कृपया स्टेटमेंट अपलोड करें"
            }
        },
        profileImage: {
            upload: {
                English: "Upload Profile Image",
                Hindi: "प्रोफ़ाइल छवि अपलोड करें"
            },
            change: {
                English: "Change Profile Image",
                Hindi: "प्रोफ़ाइल छवि बदलें"
            },
            reqError: {
                English: "Profile Image is required",
                Hindi: "प्रोफ़ाइल छवि अनिवार्य है"
            }
        },
        uploadAadharCard: {
            label: {
                English: "Upload Aadhaar Card",
                Hindi: "आधार कार्ड अपलोड करें"
            },
            reqError: {
                English: "Please upload your Aadhaar Card",
                Hindi: "कृपया अपना आधार कार्ड अपलोड करें"
            }
        },
        certInco: {
            label: {
                English: 'Certificate of Incorporation',
                Hindi: 'निगमन प्रमाणपत्र'
            }
        },
        panCard: {
            label: {
                English: 'PAN Card',
                Hindi: 'पैन कार्ड'
            }
        },
        gstCertificate: {
            label: {
                English: 'GST Certificate',
                Hindi: 'जीएसटी प्रमाणपत्र'
            }
        },
        csrCerti: {
            label: {
                English: 'CSR-1 Certificate',
                Hindi: 'सीएसआर-1 प्रमाणपत्र'
            }
        },
        darpCerti: {
            label: {
                English: 'CSR-1 Certificate',
                Hindi: 'दर्पण पंजीकरण प्रमाणपत्र'
            }
        },
        etGCert: {
            label: {
                English: '80 G Certificate',
                Hindi: '८० G प्रमाणपत्र'
            }
        },
        iAgreeTerms: {
            label: {
                English: 'I have Confirmed all the information and it is correct .!',
                Hindi: 'मैंने सारी जानकारी की पुष्टि कर ली है और यह सही है।'
            }
        },
        formSubmitted: {
            label: {
                English: 'Registration Form Submitted.',
                Hindi: 'पंजीकरण फॉर्म जमा किया गया.'
            }
        },
        thankReg: {
            label1: {
                English: 'Thank you for registering.!',
                Hindi: 'पंजीकरण के लिए धन्यवाद.!'
            },
            label2: {
                English: 'Your application is currently under review.',
                Hindi: 'आपका आवेदन वर्तमान में समीक्षा के अधीन है.'
            },
            label3: {
                English: 'Once approved, you will receive an email with your login credentials.',
                Hindi: 'एक बार स्वीकृत होने पर, आपको अपने लॉगिन क्रेडेंशियल के साथ एक ईमेल प्राप्त होगा.'
            },
            label4: {
                English: 'Application Number',
                Hindi: 'आवेदन संख्या'
            },
        },
        uploadDoc: {
            English: "Upload Documents",
            Hindi: "दस्तावेज़ अपलोड करें"
        },
        selectedFile: {
            English: "Selected file:",
            Hindi: "चयनित फ़ाइल:"
        },
        status: {
            ongoing: {
                English: "Ongoing",
                Hindi: "प्रगति पर"
            },
            completed: {
                English: "Completed",
                Hindi: "पूर्ण"
            }
        }

    },
    milestone: {
        progresssChart: {
            English: "Progress Chart",
            Hindi: "प्रगति चार्ट"
        },
        files: {
            English: "Files",
            Hindi: "फ़ाइलें"
        },
        cmpltMark: {
            English: "Mark as Complete",
            Hindi: "पूर्ण के रूप में चिन्हित करें"
        }
    },
    mouUpload: [
        { English: "Upload MOU", Hindi: "एमओयू अपलोड करें" },
        { English: "Upload MOU Document", Hindi: "एमओयू दस्तावेज़ अपलोड करें" }
    ],
    projectCreationFormData: {
        title: {
            English: 'Title of Project *',
            Hindi: 'परियोजना का शीर्षक *',
        },
        department: {
            English: 'Aligned Department *',
            Hindi: 'संरेखित विभाग *',
        },
        districts: {
            English: 'Preferred Districts *',
            Hindi: 'पसंदीदा जिले *',
        },
        units: {
            English: 'No. of Units',
            Hindi: 'इकाइयों की संख्या',
        },
        costPerUnit: {
            English: 'Cost per Unit ',
            Hindi: 'प्रति इकाई लागत',
        },
        totalBudget: {
            English: 'Total Budget',
            Hindi: 'कुल बजट',
        },
        durationYears: {
            English: 'Duration (Years) *',
            Hindi: 'अवधि (वर्ष) *',
        },
        durationMonths: {
            English: 'Duration *',
            Hindi: 'अवधि *',
        },
        sectors: {
            English: 'Sectors *',
            Hindi: 'क्षेत्र *',
        },
        sdgs: {
            English: 'Sustainable Development Goals (SDGs) *',
            Hindi: 'सतत विकास लक्ष्य (एसडीजी) *',
        },
        projectProposal: {
            English: 'Project Proposal Documents',
            Hindi: 'परियोजना प्रस्ताव दस्तावेज़',
        },
        eventGallery: {
            English: 'Event Gallery',
            Hindi: 'इवेंट गैलरी',
        },
        beneficiaries: {
            English: 'Targeted Beneficiaries *',
            Hindi: 'लक्षित लाभार्थी *',
        },
        problemStatement: {
            English: 'Problem Statement *',
            Hindi: 'समस्या का विवरण *',
        },
        projectLocation: {
            English: "Project Location",
            Hindi: "परियोजना स्थान"
        },
        selectedAddress: {
            English: "Selected Address:",
            Hindi: "चयनित पता:"
        },
        mileStone: {
            English: "Milestones",
            Hindi: "माइलस्टोन"
        },
        addMilestones: {
            English: "Add Milestone",
            Hindi: "माइलस्टोन जोड़ें"
        },
        milestoneName: {
            English: "Milestone Name *",
            Hindi: "माइलस्टोन का नाम *"
        },
        completionDate: {
            English: "Completion Date *",
            Hindi: "समाप्ति तिथि *"
        },
        percentage: {
            English: "Percentage *",
            Hindi: "प्रतिशत *"
        },
        uploadFile: {
            English: "Upload file *",
            Hindi: "फ़ाइल अपलोड करें *"
        },
        description: {
            English: "Description *",
            Hindi: "विवरण *"
        },
        selectedFile: {
            English: "Selected file",
            Hindi: "चयनित फ़ाइल"
        },
        subTitle: {
            English: "Project Basic Details",
            Hindi: "परियोजना की मूल जानकारी"
        },

        projectProposalDoc: {
            English: "Project Proposal Documents",
            Hindi: "परियोजना प्रस्ताव दस्तावेज़"
        },
        brief: {
            English: 'Brief Description of Project *',
            Hindi: 'परियोजना का संक्षिप्त विवरण *',
        },
        name: {
            English: 'Project Creation Form',
            Hindi: 'प्रोजेक्ट निर्माण प्रपत्र',
        },
        buttonSubmit: {
            English: 'Submit',
            Hindi: 'जमा करना',
        },
        buttonCancel: {
            English: 'Cancel',
            Hindi: 'रद्द करना',
        },
        outcomes: {
            English: 'Expected Outcomes of the Project *',
            Hindi: 'परियोजना के अपेक्षित परिणाम *'
        },
        sr_no: {
            English: 'S.No',
            Hindi: 'क्र.सं.'
        },
        doc_name: {
            English: 'Document Name',
            Hindi: 'दस्तावेज़ का नाम'
        },
        doc_type: {
            English: 'Document Type',
            Hindi: 'दस्तावेज़ प्रकार'
        },
        doc_size: {
            English: 'Document Size',
            Hindi: 'दस्तावेज़ आकार'
        },
        emptytable: {
            English: 'No documents added',
            Hindi: 'कोई दस्तावेज़ नहीं जोड़े गए'
        },
        add_doc: {
            English: ' Documents',
            Hindi: 'दस्तावेज़ '
        },
        selected_file: {
            English: 'Selected',
            Hindi: 'चयनित'
        },
        file_add: {
            English: 'File',
            Hindi: 'दस्तावेज़'
        },
        remove: {
            English: 'Remove',
            Hindi: 'हटाएं'
        },
        project: {
            English: "Project",
            Hindi: "परियोजना"
        },
        form: {
            English: "Form",
            Hindi: "फ़ॉर्म"
        },
        updation: {
            English: "Updation",
            Hindi: "अद्यतन"
        },
        Creation: {
            English: "Creation",
            Hindi: "निर्माण"
        },
        pendingFromProject: [
            { English: "Show Less", Hindi: "कम दिखाएं" },
            { English: "Show More", Hindi: "और दिखाएं" },
            { English: "More...", Hindi: "अधिक..." }

        ],
        Errors: [
            { English: "Title is Required", Hindi: "शीर्षक आवश्यक है" },
            { English: "Project Brief is Required", Hindi: "परियोजना विवरण आवश्यक है" },
            { English: "Department is Required", Hindi: "विभाग आवश्यक है" },
            { English: "Units is Required", Hindi: "इकाइयाँ आवश्यक हैं" },
            { English: "Cost Per Unit is Required", Hindi: "प्रति इकाई लागत आवश्यक है" },
            { English: "Beneficiaries is Required", Hindi: "लाभार्थी आवश्यक हैं" },
            { English: "Month is Required", Hindi: "माह आवश्यक है" },
            { English: "Statement is Required", Hindi: "विवरण आवश्यक है" },
            { English: "Sustainable Development Goals is Required", Hindi: "सतत विकास लक्ष्य आवश्यक हैं" },
            { English: "Sectors is Required", Hindi: "क्षेत्र आवश्यक हैं" },
            { English: "Districts is Required", Hindi: "जिले आवश्यक हैं" },
            { English: "Outcomes is Required", Hindi: "परिणाम आवश्यक हैं" },
            { English: "Project Proposal Documents is Required*", Hindi: "परियोजना प्रस्ताव दस्तावेज़ आवश्यक हैं*" },
            { English: "Type is Required", Hindi: "प्रकार आवश्यक है" },
            { English: "Milestone name is Required", Hindi: "माइलस्टोन नाम आवश्यक है" },
            { English: "Description is Required", Hindi: "विवरण आवश्यक है" },
            { English: "Percentage is Required", Hindi: "प्रतिशत आवश्यक है" },
            { English: "Amount is Required", Hindi: "राशि आवश्यक है" },
            { English: "Completion date is Required", Hindi: "पूर्णता तिथि आवश्यक है" },
            { English: "File is Required", Hindi: "फ़ाइल आवश्यक है" },
            { English: "Total milestone amount must exactly match the total budget", Hindi: "कुल माइलस्टोन राशि कुल बजट के बराबर होनी चाहिए" },
            { English: "Total milestone percentage must be exactly 100%", Hindi: "कुल माइलस्टोन प्रतिशत बिल्कुल 100% होना चाहिए" },
            { English: "Please Add Project Proposal Documents", Hindi: "कृपया परियोजना प्रस्ताव दस्तावेज़ जोड़ें" },
            { English: "Project Updated Successfully", Hindi: "परियोजना सफलतापूर्वक अपडेट की गई" },
            { English: "Project Created Successfully", Hindi: "परियोजना सफलतापूर्वक बनाई गई" }
        ],

        status: [
            { English: "Approve", Hindi: "स्वीकृत" },
            { English: "Reject", Hindi: "अस्वीकृत" },
            { English: "Completed", Hindi: "पूर्ण" },
            { English: "Remarks:", Hindi: "टिप्पणियाँ" }
        ]

    },
    ProjectDetails: [
        { English: "Project Overview", Hindi: "परियोजना का अवलोकन" },
        { English: "Budget Overview", Hindi: "बजट का अवलोकन" },
        { English: "Aligned Department", Hindi: "संबद्ध विभाग" },
        { English: "Project Created Date", Hindi: "परियोजना निर्माण तिथि" },
        { English: "Project Created By", Hindi: "परियोजना किसके द्वारा बनाई गई" },
        { English: "Sectors", Hindi: "क्षेत्र" },
        { English: "Total Budget", Hindi: "कुल बजट" },
        { English: "Total Committed", Hindi: "कुल प्रतिबद्ध राशि" },
        { English: "Remaining Amount", Hindi: "शेष राशि" },
        { English: "No permissions", Hindi: "अनुमतियाँ नहीं हैं" },
        { English: "Assign to Agency", Hindi: "एजेंसी को सौंपें" },
        { English: "Show Your Interest", Hindi: "अपनी रुचि दिखाएं" },
        { English: "Remove From Interest", Hindi: "रुचि से हटाएं" },
        { English: "Commitment", Hindi: "प्रतिबद्धता" },
        { English: "Total", Hindi: "कुल" },
        { English: "View", Hindi: "देखें" },
        { English: "Download", Hindi: "डाउनलोड करें" },
        { English: "Agency", Hindi: "एजेंसी" },
        { English: "Disbursement", Hindi: "वितरण" },
        { English: "Accept", Hindi: "स्वीकार करें" },
        { English: "Reject", Hindi: "अस्वीकार करें" },
        { English: "Approve", Hindi: "स्वीकृत करें" }

    ],
    dashboardSummary: {
        mainTitle: {
            English: "CSR Expenditure Summary: Bihar",
            Hindi: "सीएसआर व्यय सारांश: बिहार"
        },
        title: {
            English: "CSR Spent: Geographical Distribution",
            Hindi: "सीएसआर व्यय: भौगोलिक वितरण"
        },
        title2: {
            English: "Top 10 Companies",
            Hindi: "शीर्ष 10 कंपनियाँ"
        },
        title3: {
            English: "Top 10 Districts",
            Hindi: "शीर्ष 10 जिले"
        },
        title4: {
            English: "Top 10 Sectors",
            Hindi: "शीर्ष 10 सेक्टर"
        },
        title5: {
            English: "Comparative Report",
            Hindi: "तुलनात्मक रिपोर्ट"
        },
        legendTitle: {
            English: "CSR Spending Legend",
            Hindi: "सीएसआर व्यय संकेतक"
        },
        spent: {
            English: "Zero Spent",
            Hindi: "शून्य खर्च"
        },
        amountSpent: {
            English: "Amount Spent (INR Cr.)",
            Hindi: "व्यय राशि (₹ करोड़ में)"
        },
        Footer: {
            English: "© 2025 Sri Siddhguru CSR Portal. All rights reserved",
            Hindi: "© 2025 सीएसआर बिहार सरकार। सर्वाधिकार सुरक्षित।"
        },
        successStory: {
            English: "Our CSR Focus Area",
            Hindi: "सफलता की कहानी"
        },
        PhotoGallery: {
            English: "Photo Gallery",
            Hindi: "फोटो गैलरी"
        },
        developmentSectors: {
            English: "Development Sectors",
            Hindi: "विकास क्षेत्र"
        },
        financialYear: {
            English: "Financial Year",
            Hindi: "वित्तीय वर्ष"
        },
        skip: {
            English: "Skip to main content",
            Hindi: "मुख्य अनुभाग पर जाएं"
        },
        fontSize: {
            English: "Font Size",
            Hindi: "फ़ॉन्ट आकार"
        },
        projectCategory: {
            English: "Project Categories",
            Hindi: "परियोजना श्रेणियाँ"
        },
        events: {
            eventypes: {
                upcomingEvent: {
                    English: "Upcoming Events",
                    Hindi: "आगामी आयोजन"
                },
                pastEvent: {
                    English: 'Past Events',
                    Hindi: "पूर्व आयोजन"
                }

            }
        },
        noData: {
            English: "Please check your filters or try refreshing the page.",
            Hindi: "कृपया अपने फ़िल्टर जांचें या पेज को रिफ्रेश करने का प्रयास करें।"
        },
        noDataFound: {
            English: "No Data Found",
            Hindi: "कोई डेटा नहीं मिला"
        },
    },

    headCellProjectData: [
        { sr_no: { English: 'Sr No.', Hindi: 'क्रम संख्या' } },
        { title: { English: 'Project Name', Hindi: 'परियोजना का नाम' } },
        { aligned_department: { English: 'Aligned Department', Hindi: 'सम्बद्ध विभाग' } },
        { preferred_districts: { English: 'Preferred Districts', Hindi: 'पसंदीदा जिले' } },
        { Nos_of_units: { English: 'Nos of Units', Hindi: 'इकाइयों की संख्या' } },
        { cost_per_unit: { English: 'Cost per Unit (₹)', Hindi: 'प्रति इकाई लागत (₹)' } },
        { total_budget: { English: 'Total Budget (₹)', Hindi: 'कुल बजट (₹)' } },
        { total_commitment: { English: 'Total Commitment (₹)', Hindi: 'कुल बजट (₹)' } },
        { remaining_amount: { English: 'Remaining Amount (₹)', Hindi: 'कुल बजट (₹)' } },
        { created_by_name: { English: 'User Type ', Hindi: 'उपयोगकर्ता प्रकार' } },
        { create_date: { English: 'Created Date', Hindi: 'निर्माण तारीख' } },
        { duration: { English: 'Duration', Hindi: 'अवधि' } },
        { pending_from: { English: 'Pending From', Hindi: 'अवधि' } },
        { status: { English: 'Project Status', Hindi: 'परियोजना स्थिति' } },
        { committed_units: { English: 'Committed Units', Hindi: 'प्रतिबद्ध इकाइयां' } },
        { committed_amount: { English: 'Committed Amount (₹)', Hindi: 'प्रतिबद्ध राशि (₹)' } },
        { name_of_organisation: { English: 'Name of Organization / User', Hindi: 'संगठन का नाम / उपयोगकर्ता' } },
        { Action: { English: 'Action', Hindi: 'क्रिया' } }
    ],

    cardProjectData: {
        TotalProject: {
            English: 'Total ',
            Hindi: 'कुल ',
        },
        ApprovedProjects: {
            English: 'Approved ',
            Hindi: 'स्वीकृत ',
        },
        CompletedProjects: {
            English: 'Completed',
            Hindi: 'पूर्ण',
        },
        OnGoingProject: {
            English: 'Ongoing ',
            Hindi: 'चल रही परियोजनाएं '
        },
        MyCommittedProjects: {
            English: 'Committed Amount',
            Hindi: 'स्वीकृत परियोजनाएं',
        },
        MyCommittedAmount: {
            English: 'Bugdet Amount',
            Hindi: 'स्वीकृत परियोजनाएं',
        },
        TotalAmount: {
            English: 'Total Commitment',
            Hindi: 'स्वीकृत परियोजनाएं',
        },
        Projectspending: {
            English: 'Pending ',
            Hindi: 'लंबित ',
        },
        RejectedProjects: {
            English: 'Rejected ',
            Hindi: 'अस्वीकृत ',
        }
    },

    cardSubProjectData: {
        Projectspending: {
            English: 'Aligned Department',
            Hindi: 'संरेखित विभाग',
        },
        RejectedProjects: {
            English: 'CSR Cell',
            Hindi: 'सीएसआर कक्ष',
        }

    },

    menuLabels: {
        registeredUsers: { English: "Registered Users", Hindi: "पंजीकृत उपयोगकर्ता" },
        csrProjects: { English: "CSR Projects", Hindi: "सीएसआर परियोजनाएँ" },
        knowledgeBase: { English: "Knowledge Base", Hindi: "ज्ञान आधार" },
        EventMedia: { English: "Event and Media", Hindi: "इवेंट और मीडिया" },
        CSRCOMMITEE: { English: "CSR Society", Hindi: "सीएसआर समिति" },

    },

    warningChangeUserType: {
        title: {
            English: 'Confirm Registration Type Change',
            Hindi: 'पंजीकरण प्रकार परिवर्तन की पुष्टि करें'
        },
        message: {
            English: "<b> Are you sure you want to change the registration type?</b> <br /><br />If you proceed, the <b> current inputs will be cleared and you'll need to re-enter </b> all required details based on the <b> newly selected registration type.</b>",
            Hindi: "<b> क्या आप वाकई पंजीकरण प्रकार बदलना चाहते हैं?</b> <br /><br />यदि आप आगे बढ़ते हैं, तो <b>वर्तमान इनपुट्स हटा दिए जाएंगे और</b> आपको <b>नए चयनित पंजीकरण प्रकार</b> के अनुसार सभी आवश्यक विवरण दोबारा दर्ज करने होंगे।"
        },
        nobtn: {
            English: 'No',
            Hindi: 'नहीं'
        },
        yesbtn: {
            English: 'Yes',
            Hindi: 'हाँ'
        }

    },

    stepButton: {
        back: {
            English: 'Back',
            Hindi: 'पीछे'
        },
        next: {
            English: 'Next',
            Hindi: 'अगला'
        },
        submit: {
            English: 'Submit',
            Hindi: 'जमा करें'
        },
        submitting: {
            English: 'Submitting...',
            Hindi: 'जमा कर रहे हैं...'
        },
    },

    sewaVolunteer: {
        title: {
            English: 'Sewa Volunteer Registration',
            Hindi: 'सेवा स्वयंसेवक पंजीकरण'
        },
        category: {
            label: { English: 'Category', Hindi: 'श्रेणी' },
            placeholder: { English: 'Select Sewa Kshetras', Hindi: 'सेवा श्रेणी चुनें' },
            reqerror: { English: 'Category is required', Hindi: 'श्रेणी आवश्यक है' }
        },
        name: {
            label: { English: 'Name of Volunteer', Hindi: 'स्वयंसेवक का नाम' },
            reqerror: { English: 'Name is required', Hindi: 'नाम आवश्यक है' }
        },
        email: {
            label: { English: 'Email', Hindi: 'ईमेल' },
            reqerror: { English: 'Email is required', Hindi: 'ईमेल आवश्यक है' },
            formaterror: { English: 'Invalid email format', Hindi: 'अमान्य ईमेल प्रारूप' }
        },
        contact: {
            label: { English: 'Mobile Number', Hindi: 'मोबाइल नंबर' },
            reqerror: { English: 'Mobile Number is required', Hindi: 'मोबाइल नंबर आवश्यक है' },
            formaterror: { English: 'Enter a valid 10-digit number', Hindi: '10 अंकों का मान्य नंबर दर्ज करें' }
        },
        education: {
            label: { English: 'Education', Hindi: 'शिक्षा' },
            reqerror: { English: 'Education is required', Hindi: 'शिक्षा आवश्यक है' }
        },
        profesionalCareer: {
            label: { English: 'Professional Career', Hindi: 'व्यावसायिक कैरियर' },
            reqerror: { English: 'Professional Career is required', Hindi: 'व्यावसायिक कैरियर आवश्यक है' }
        },
        businessOrganization: {
            label: { English: 'Business Organization', Hindi: 'व्यवसाय / संगठन' },
            reqerror: { English: 'Business Organization is required', Hindi: 'व्यवसाय / संगठन आवश्यक है' }
        },
        designation: {
            label: { English: 'Designation', Hindi: 'पदनाम' },
            reqerror: { English: 'Designation is required', Hindi: 'पदनाम आवश्यक है' }
        },
        socialAttributes: {
            label: { English: 'Social Attributes', Hindi: 'सामाजिक विशेषताएँ' },
            reqerror: { English: 'Social Attributes is required', Hindi: 'सामाजिक विशेषताएँ आवश्यक है' }
        },
        rolesAssigned: {
            label: { English: 'Roles Assigned', Hindi: 'निर्धारित भूमिका' },
            reqerror: { English: 'Roles Assigned is required', Hindi: 'निर्धारित भूमिका आवश्यक है' }
        },
        officeAddress: {
            label: { English: 'Address', Hindi: 'पता' },
            reqerror: { English: 'Address is required', Hindi: 'पता आवश्यक है' }
        },
        pinCode: {
            label: { English: 'Pin Code', Hindi: 'पिन कोड' },
            reqerror: { English: 'Pin Code is required', Hindi: 'पिन कोड आवश्यक है' },
            validerror: { English: 'Please enter a valid Pin Code', Hindi: 'कृपया एक मान्य पिन कोड दर्ज करें' }
        },
        stateName: {
            label: { English: 'State Name', Hindi: 'राज्य का नाम' },
            reqerror: { English: 'State Name is required', Hindi: 'राज्य का नाम आवश्यक है' }
        },
        districtName: {
            label: { English: 'District Name', Hindi: 'जिले का नाम' },
            reqerror: { English: 'District Name is required', Hindi: 'जिले का नाम आवश्यक है' }
        },
        profilePhoto: {
            label: { English: 'Profile Photo', Hindi: 'प्रोफ़ाइल फ़ोटो' },
            upload: { English: 'Upload Photo', Hindi: 'फ़ोटो अपलोड करें' },
            change: { English: 'Change Photo', Hindi: 'फ़ोटो बदलें' },
            reqerror: { English: 'Profile Photo is required', Hindi: 'प्रोफ़ाइल फ़ोटो आवश्यक है' }
        },
        interestedSewas: {
            label: { English: 'Interested Sewas', Hindi: 'रुचि की सेवाएँ' },
            addRow: { English: 'Add ', Hindi: 'जोड़ें' }
        },
        sewaHistories: {
            label: { English: 'Sewa Histories', Hindi: 'सेवा इतिहास' },
            addRow: { English: 'Add', Hindi: 'जोड़ें' }
        },
        selectSewa: {
            label: { English: 'Select Sewa', Hindi: 'सेवा चुनें' },
            reqerror: { English: 'Sewa is required', Hindi: 'सेवा आवश्यक है' }
        },
        supportRequired: {
            label: { English: 'Support Required', Hindi: 'आवश्यक सहयोग' },
            reqerror: { English: 'Support Required is required', Hindi: 'आवश्यक सहयोग आवश्यक है' }
        },
        description: {
            label: { English: 'Description', Hindi: 'विवरण' },
            reqerror: { English: 'Description is required', Hindi: 'विवरण आवश्यक है' }
        },
        sewaDate: {
            label: { English: 'Sewa Date', Hindi: 'सेवा तिथि' },
            reqerror: { English: 'Sewa Date is required', Hindi: 'सेवा तिथि आवश्यक है' }
        },
        sewaDocument: {
            label: { English: 'Upload Document', Hindi: 'दस्तावेज़ अपलोड करें' },
            reqerror: { English: 'Document is required', Hindi: 'दस्तावेज़ आवश्यक है' }
        }
    },

    topBarFonts: {
        English: "A",
        Hindi: "अ"
    },

    notifications: {
        mainTitle: {
            English: "Notifications",
            Hindi: "सूचनाएँ"
        },
        notificationLoading: {
            English: "Loading notifications...",
            Hindi: "सूचनाएँ लोड हो रही हैं..."
        },
        noNotification: {
            English: "No Notifications Found",
            Hindi: "कोई सूचनाएँ नहीं मिलीं"
        },
        allNotification: {
            English: "See All Notifications",
            Hindi: "सभी सूचनाएँ देखें"
        }
    },
    help: {
        English: "Help and Support",
        Hindi: "सहायता और समर्थन"
    },
    successStory: [
        {
            company: { English: "JM Financial", Hindi: "जेएम फाइनेंशियल" },
            district: { English: "Jamui", Hindi: "जमुई" },
            initiative: { English: "Rural Development", Hindi: "ग्रामीण विकास" },
            description: {
                English: "Launched in March 2018, the Model Village Development Project aims to make 15 villages in Sikandra block self-reliant by supporting over 3,000 small farmers and promoting rural livelihoods. In Muzaffarpur, ₹24 crore is being invested in hospital infrastructure, including a 100-bed waiting hall and a multipurpose hall. ",
                Hindi: "मार्च 2018 में शुरू की गई मॉडल गांव विकास परियोजना का लक्ष्य सिकंदरा प्रखंड के 15 गांवों को आत्मनिर्भर बनाना है, जिसमें 3,000 से अधिक छोटे किसानों का समर्थन किया जा रहा है और ग्रामीण आजीविका को बढ़ावा दिया जा रहा है। मुजफ्फरपुर में ₹24 करोड़ की राशि अस्पताल अवसंरचना पर निवेश की जा रही है, जिसमें 100-बेड का वेटिंग हॉल और एक बहुउद्देशीय हॉल शामिल है। ",
            },
            image: "/Projects/jmf.png",
        },
        {
            company: { English: "REC Limited", Hindi: "आरईसी लिमिटेड" },
            district: { English: "Muzafarpur", Hindi: "मुजफ्फरपुर" },
            initiative: { English: "Renewable Energy", Hindi: "नवीकरणीय ऊर्जा" },
            description: {
                English:
                    "REC Limited (formerly Rural Electrification Corporation Limited) is a 'Navratna' company under the administrative control of the Ministry of Power. In 2020 alone, REC launched CSR projects worth ₹32 crore in Bihar.Union Minister of State for Power and New & Renewable Energy, Mr. R. K. Singh, inaugurated these initiatives digitally.",
                Hindi:
                    "आरईसी लिमिटेड (पूर्व में रूरल इलेक्ट्रिफिकेशन कॉरपोरेशन लिमिटेड) एक 'नवरत्न' कंपनी है, जो विधुत मंत्रालय के प्रशासनिक नियंत्रण में कार्यरत है। वर्ष 2020 में ही, आरईसी ने बिहार में ₹32 करोड़ की सीएसआर परियोजनाएं शुरू कीं। केंद्रीय विधुत एवं नवीन और नवीकरणीय ऊर्जा राज्य मंत्री श्री आर. के. सिंह ने इन पहलों का डिजिटल उद्घाटन किया।"
            },
            image: "/Projects/recltd.png",
        },
        {
            company: { English: "HDFC Bank", Hindi: "एचडीएफसी बैंक" },
            district: { English: "Samastipur", Hindi: "समस्तीपुर" },
            initiative: {
                English: "Holistic Rural Development Programme",
                Hindi: "समग्र ग्रामीण विकास कार्यक्रम",
            },
            description: {
                English:
                    "HDFC Bank’s Holistic Rural Development Programme (HRDP) is working towards strengthening social, physical, and institutional infrastructure in over 95 villages. In Samastipur district, the bank has implemented an organic farming training initiative in four villages — Pahepur, Bishanpur Bande, Narayanpur Dadhiya, and Garuara — thereby promoting alternative livelihood opportunities",
                Hindi:
                    "एचडीएफसी बैंक का समग्र ग्रामीण विकास कार्यक्रम (HRDP) बिहार के 7 जिलों के 95 से अधिक गांवों में सामाजिक, भौतिक और संस्थागत अवसंरचना को सुदृढ़ करने का कार्य कर रहा है। समस्तीपुर जिले के चार गांव — पाहेपुर, बिशनपुर बंदे, नारायणपुर दधिया और गरुआरा — में बैंक की जैविक कृषि प्रशिक्षण योजना का संचालन किया गया, जिससे वैकल्पिक आजीविका के अवसरों को बढ़ावा मिला।",
            },
            image: "/Projects/hdfc.png",
        },
        {
            company: { English: "IBM", Hindi: "आईबीएम" },
            district: { English: "Patna", Hindi: "पटना" },
            initiative: {
                English: "Science, Technology, Engineering and Math (STEM)",
                Hindi: "विज्ञान, प्रौद्योगिकी, इंजीनियरिंग और गणित (एसटीईएम)",
            },
            description: {
                English:
                    "IBM’s ‘STEM for Girls’ CSR initiative aims to empower government school girls by enhancing their education-to-career journey through skill development. The program offers training in digital literacy, coding, 21st-century skills, and career planning. IBM has partnered with the Bihar Education Department to implement this program in 30 higher secondary schools across the state.",
                Hindi:
                    "आईबीएम की ‘STEM फॉर गर्ल्स’ सीएसआर पहल का उद्देश्य सरकारी स्कूलों की छात्राओं को कौशल विकास के माध्यम से शिक्षा से करियर तक की यात्रा को सशक्त बनाना है। यह कार्यक्रम डिजिटल साक्षरता, कोडिंग, 21वीं सदी के कौशल और करियर योजना में प्रशिक्षण प्रदान करता है। आईबीएम ने इस कार्यक्रम को राज्य भर के 30 उच्च माध्यमिक विद्यालयों में लागू करने के लिए बिहार शिक्षा विभाग के साथ साझेदारी की है।",
            },
            image: "/Projects/ibm.png",
        },
    ],

    agencyContactPerson: {
        English: {
            contactPerson: {
                required: "Contact person name is required",
                match: "Only letters and spaces are allowed",
                min: "Must be at least 2 characters",
                max: "Must be at most 50 characters",
            },
            designation: {
                required: "Designation is required",
                match: "Only letters and spaces are allowed",
                min: "Must be at least 2 characters",
                max: "Must be at most 50 characters",
            },
            mobile: {
                required: "Mobile number is required",
                invalid: "Mobile number must be exactly 10 digits",
            },
            email: {
                required: "Email is required",
                invalid: "Invalid email format",
            },
        },
        Hindi: {
            contactPerson: {
                required: "संपर्क व्यक्ति का नाम आवश्यक है",
                match: "केवल अक्षर और स्पेस ही मान्य हैं",
                min: "कम से कम 2 अक्षर होने चाहिए",
                max: "अधिकतम 50 अक्षर होने चाहिए",
            },
            designation: {
                required: "पदनाम आवश्यक है",
                match: "केवल अक्षर और स्पेस ही मान्य हैं",
                min: "कम से कम 2 अक्षर होने चाहिए",
                max: "अधिकतम 50 अक्षर होने चाहिए",
            },
            mobile: {
                required: "मोबाइल नंबर आवश्यक है",
                invalid: "मोबाइल नंबर ठीक 10 अंकों का होना चाहिए",
            },
            email: {
                required: "ईमेल आवश्यक है",
                invalid: "अमान्य ईमेल फॉर्मेट",
            },
        },
    },

    agencyCSRFunding: {
        English: {
            projectName: {
                required: "Project name is required",
                min: "Project name must be at least 3 characters",
                max: "Project name can't exceed 100 characters",
            },
            projectDescription: {
                required: "Project description is required",
                min: "Description must be at least 10 characters",
                max: "Description can't exceed 500 characters",
            },
            sector: "Sector is required",
            amount: {
                required: "Amount is required",
                typeError: "Amount must be a valid number",
                positive: "Amount must be a positive number",
            },
            state: "State is required",
            status: "Status is required",
            donorName: {
                required: "Sewa Partner name is required",
                min: "Sewa Partner name must be at least 3 characters",
                max: "Sewa Partner name can't exceed 100 characters",
            },
            concernedPerson: "Concerned person name is required",
            email: {
                required: "Email is required",
                invalid: "Invalid email",
            },
        },
        Hindi: {
            projectName: {
                required: "परियोजना का नाम आवश्यक है",
                min: "परियोजना का नाम कम से कम 3 अक्षर का होना चाहिए",
                max: "परियोजना का नाम 100 अक्षरों से अधिक नहीं हो सकता",
            },
            projectDescription: {
                required: "परियोजना विवरण आवश्यक है",
                min: "विवरण कम से कम 10 अक्षर का होना चाहिए",
                max: "विवरण 500 अक्षरों से अधिक नहीं हो सकता",
            },
            sector: "सेक्टर आवश्यक है",
            amount: {
                required: "राशि आवश्यक है",
                typeError: "राशि एक मान्य संख्या होनी चाहिए",
                positive: "राशि एक सकारात्मक संख्या होनी चाहिए",
            },
            state: "राज्य आवश्यक है",
            status: "स्थिति आवश्यक है",
            donorName: {
                required: "डोनर का नाम आवश्यक है",
                min: "डोनर का नाम कम से कम 3 अक्षर का होना चाहिए",
                max: "डोनर का नाम 100 अक्षरों से अधिक नहीं हो सकता",
            },
            concernedPerson: "संपर्क व्यक्ति का नाम आवश्यक है",
            email: {
                required: "ईमेल आवश्यक है",
                invalid: "अमान्य ईमेल",
            },
        },
    },

    csrFundingForm: [

    ],

    agencyOrganisation: {
        English: {
            typeOfCompany: "Type of Company is required",
            cin: {
                required: "CIN is required for Section companies",
                invalid: "CIN format is invalid",
            },
            organisationName: {
                required: "Organization name is required",
                min: "Organization name must be at least 2 characters",
            },
            email: {
                required: "Email is required",
                invalid: "Please enter a valid email address",
            },
            mobile: {
                required: "Mobile number is required",
                invalid: "Mobile number must be 10 digits starting with 1-9",
            },
            dateOfInc: {
                required: "Date of Incorporation is required",
                max: "Date of Incorporation cannot be in the future",
            },
            registerAdd: {
                required: "Registered Address is required",
                min: "Registered Address must be at least 5 characters",
            },
            pinCode: {
                required: "PIN Code is required",
                invalid: "PIN Code must be exactly 6 digits",
            },
            stateName: {
                required: "State name is required",
                invalid: "State name can only contain letters and spaces",
            },
            districtName: {
                required: "District name is required",
                invalid: "District name can only contain letters and spaces",
            },
            gst: {
                required: "GST number is required",
                invalid: "GST must be a valid 15-character code",
                length: "GST must be exactly 15 characters",
            },
            pan: {
                required: "PAN is required",
                invalid: "PAN must be a valid 10-character code",
                length: "PAN must be exactly 10 characters",
            },
            officeAdd: {
                required: "Office Address is required",
                min: "Office Address must be at least 5 characters",
            },
            csrRegNo: {
                required: "CSR-1 Certificate Number is required",
                invalid: "CSR-1 number must be exactly 19 digits.",
            }
        },
        Hindi: {
            typeOfCompany: "कंपनी का प्रकार आवश्यक है",
            cin: {
                required: "Section कंपनी के लिए CIN आवश्यक है",
                invalid: "CIN प्रारूप अमान्य है",
            },
            organisationName: {
                required: "संगठन का नाम आवश्यक है",
                min: "संगठन का नाम कम से कम 2 अक्षर होना चाहिए",
            },
            email: {
                required: "ईमेल आवश्यक है",
                invalid: "कृपया एक मान्य ईमेल दर्ज करें",
            },
            mobile: {
                required: "मोबाइल नंबर आवश्यक है",
                invalid: "मोबाइल नंबर 1-9 से शुरू होने वाले 10 अंकों का होना चाहिए",
            },
            dateOfInc: {
                required: "पंजीकरण की तारीख आवश्यक है",
                max: "पंजीकरण की तारीख भविष्य में नहीं हो सकती",
            },
            registerAdd: {
                required: "पंजीकृत पता आवश्यक है",
                min: "पंजीकृत पता कम से कम 5 अक्षरों का होना चाहिए",
            },
            pinCode: {
                required: "पिन कोड आवश्यक है",
                invalid: "पिन कोड ठीक 6 अंकों का होना चाहिए",
            },
            stateName: {
                required: "राज्य का नाम आवश्यक है",
                invalid: "राज्य का नाम केवल अक्षर और स्पेस हो सकता है",
            },
            districtName: {
                required: "जिले का नाम आवश्यक है",
                invalid: "जिले का नाम केवल अक्षर और स्पेस हो सकता है",
            },
            gst: {
                required: "GST नंबर आवश्यक है",
                invalid: "GST एक मान्य 15-अक्षर कोड होना चाहिए",
                length: "GST ठीक 15 अक्षर का होना चाहिए",
            },
            pan: {
                required: "PAN आवश्यक है",
                invalid: "PAN एक मान्य 10-अक्षर कोड होना चाहिए",
                length: "PAN ठीक 10 अक्षर का होना चाहिए",
            },
            officeAdd: {
                required: "कार्यालय का पता आवश्यक है",
                min: "कार्यालय का पता कम से कम 5 अक्षरों का होना चाहिए",
            },
            csrRegNo: {
                required: "CSR-1 प्रमाणपत्र संख्या आवश्यक है",
                invalid: "CSR-1 संख्या ठीक 19 अंकों की होनी चाहिए"
            }
        },
    },

    TenderList: [
        {
            id: 1,
            tenderId: "92097",
            description: {
                English: "For establishment of Computer Lab in Other Backward Class Girls Residential High School in Bihar",
                Hindi: "बिहार में पिछड़ा वर्ग कन्या आवासीय उच्च विद्यालय में कंप्यूटर लैब की स्थापना हेतु",
            },
            referenceNo: "NIGAM/COMPUTER",
            department: {
                English: "Bc & EBC Welfare, Bihar , Patna",
                Hindi: "अत्यंत पिछड़ा वर्ग कल्याण विभाग, बिहार, पटना",
            },
            endDate: "2025-03-10 13:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" },
        },
        {
            id: 2,
            tenderId: "92096",
            description: {
                English: "For establishment of Smart Class in Other Backward Class Girls Residential High School in Bihar",
                Hindi: "बिहार में पिछड़ा वर्ग कन्या आवासीय उच्च विद्यालय में स्मार्ट कक्षा की स्थापना हेतु",
            },
            referenceNo: "NIGAM/SMART CLASS",
            department: {
                English: "Bc & EBC Welfare, Bihar , Patna",
                Hindi: "अत्यंत पिछड़ा वर्ग कल्याण विभाग, बिहार, पटना",
            },
            endDate: "2025-03-10 13:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" },
        },
        {
            id: 3,
            tenderId: "91837",
            description: {
                English: "Construction of new 50’x30’ shed with electrical work, Heating Chamber, Gantry, 50m length boundary wall",
                Hindi: "नया 50'x30' शेड का निर्माण, विधुत कार्य, हीटिंग चैम्बर, गैंट्री और 50 मीटर लंबी बाउंड्री वाल सहित",
            },
            referenceNo: "20/PR/NBPDCL/2025",
            department: {
                English: "NORTH BIHAR POWER DISTRIBUTION COMPANY LIMITED",
                Hindi: "उत्तर बिहार पावर डिस्ट्रीब्यूशन कंपनी लिमिटेड",
            },
            endDate: "2025-03-10 13:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Past Tenders", Hindi: "पूर्व निविदाएं" },
        },
        {
            id: 4,
            tenderId: "92321",
            description: {
                English:
                    "Repair, Painting and Modernization work including Civil, Electrical & A.C. Work of Nursing Station, Nurse room, etc.",
                Hindi: "नर्सिंग स्टेशन, नर्स कक्ष आदि का मरम्मत, पेंटिंग एवं आधुनिकीकरण कार्य (सिविल, विधुत एवं ए.सी. कार्य सहित)",
            },
            referenceNo: "10/IGIMS/ENGG.CE",
            department: {
                English: "Indira Gandhi Institute Of Medical Sciences",
                Hindi: "इंदिरा गांधी आयुर्विज्ञान संस्थान",
            },
            endDate: "2025-03-10 23:59",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" },
        },
        {
            id: 5,
            tenderId: "92508",
            description: {
                English:
                    "Proposed UPVC Cabin and Lab Table for Research Laboratory at 3rd Floor of New RIO Building at IGIMS, Patna",
                Hindi: "आईजीआईएमएस, पटना के नए आरआईओ भवन की तीसरी मंजिल पर अनुसंधान प्रयोगशाला हेतु प्रस्तावित यूपीवीसी केबिन और लैब टेबल",
            },
            referenceNo: "10/IGIMS/ENGG.CE",
            department: {
                English: "Indira Gandhi Institute Of Medical Sciences",
                Hindi: "इंदिरा गांधी आयुर्विज्ञान संस्थान",
            },
            endDate: "2025-03-10 23:59",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" },
        },
        {
            id: 6,
            tenderId: "92749",
            description: {
                English:
                    "Supply of Kota Stone, Stamped Concrete, Marble stones etc as mentioned in the bid documents",
                Hindi: "कोटा पत्थर, स्टैम्प्ड कंक्रीट, संगमरमर आदि की आपूर्ति (निविदा दस्तावेज़ के अनुसार)",
            },
            referenceNo: "ref/03/2024-25",
            department: {
                English: "Environment, Forest & Climate Change Department",
                Hindi: "पर्यावरण, वन एवं जलवायु परिवर्तन विभाग",
            },
            endDate: "2025-03-11 12:30",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" },
        },
        {
            id: 7,
            tenderId: "93027",
            description: {
                English:
                    "Construction of Drain from Janardan Mandal House to Maleshwar Mandal House via Bhairo Mandal Bunglow",
                Hindi: "जनार्दन मंडल घर से लेकर भैरव मंडल बंगला होते हुए मलेश्वर मंडल घर तक नाला निर्माण",
            },
            referenceNo: "NIT No.-01/2024-25",
            department: {
                English: "Bihar Urban Infrastructure Development Corporation Ltd.",
                Hindi: "बिहार शहरी आधारभूत संरचना विकास निगम लिमिटेड",
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" },
        },
        {
            id: 8,
            tenderId: "92741",
            description: {
                English: "INSTALLATION, SUPPLY, TESTING AND COMMISSIONING OF FIRE FIGHTING WORKS AT DIFFERENT COURT BUILDINGS",
                Hindi: "विभिन्न न्यायालय भवनों में अग्निशमन कार्यों की स्थापना, आपूर्ति, परीक्षण और चालू करने का कार्य"
            },
            referenceNo: "40/BCD/HAJIPUR/2025",
            department: {
                English: "Building Construction Department",
                Hindi: "भवन निर्माण विभाग"
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" }
        },
        {
            id: 9,
            tenderId: "92229",
            description: {
                English: "FIRE FIGHTING WORK IN DIFFERENT BUILDINGS AT CIVIL COURT, MOTIHARI",
                Hindi: "सिविल कोर्ट, मोतिहारी में विभिन्न भवनों में अग्निशमन कार्य"
            },
            referenceNo: "33/BCD/MOTIHARI/2025",
            department: {
                English: "Building Construction Department",
                Hindi: "भवन निर्माण विभाग"
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" }
        },
        {
            id: 10,
            tenderId: "90899",
            description: {
                English: "Provision of Audio Conference System for Bihar Legislative Assembly with five years Operation and Maintenance",
                Hindi: "बिहार विधान सभा के लिए ऑडियो कॉन्फ्रेंस सिस्टम की आपूर्ति एवं पाँच वर्षों तक संचालन और रखरखाव"
            },
            referenceNo: "24/BCD/EWD 3/2025",
            department: {
                English: "Building Construction Department",
                Hindi: "भवन निर्माण विभाग"
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" }
        },
        {
            id: 11,
            tenderId: "93023",
            description: {
                English: "Construction of Road from Karela Mandal House to the front of Bajrangvali Mandir via Khagesh Mandal House",
                Hindi: "करेला मंडल घर से खगेश मंडल घर होते हुए बजरंगवली मंदिर तक सड़क निर्माण"
            },
            referenceNo: "NIT No.-01/2024-25",
            department: {
                English: "Bihar Urban Infrastructure Development Corporation Ltd.",
                Hindi: "बिहार शहरी आधारभूत संरचना विकास निगम लिमिटेड"
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" }
        },
        {
            id: 12,
            tenderId: "93020",
            description: {
                English: "Construction of Road from NH-80 (Purani Fadhi) to Kali Ghat Main Road via Jagannath Mandir and via Prem Jalil House",
                Hindi: "एनएच-80 (पुरानी फाड़ी) से काली घाट मुख्य सड़क तक, जगन्नाथ मंदिर और प्रेम जलील घर होकर सड़क निर्माण"
            },
            referenceNo: "NIT No.-01/2024-25",
            department: {
                English: "Bihar Urban Infrastructure Development Corporation Ltd.",
                Hindi: "बिहार शहरी आधारभूत संरचना विकास निगम लिमिटेड"
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" }
        },
        {
            id: 13,
            tenderId: "93012",
            description: {
                English: "Desilting of different drains connecting to Kabar lake and construction of check dam in Begusarai district",
                Hindi: "कबर झील से जुड़े विभिन्न नालों की सफाई और बेगूसराय जिले में चेक डैम का निर्माण"
            },
            referenceNo: "NIT No-01SBD/2025",
            department: {
                English: "Water Resources Department",
                Hindi: "जल संसाधन विभाग"
            },
            endDate: "2025-03-11 15:00",
            rollBack: { English: "No", Hindi: "नहीं" },
            category: { English: "Latest Tenders", Hindi: "नवीनतम निविदाएं" }
        }
    ],

    photoGallry: {
        title: {
            English: "Photo Gallery",
            Hindi: "फोटो गैलरी",
        },
        healthcare: {
            English: "Healthcare Initiatives:\nFree medical camps and mobile healthcare units.\nDistribution of essential medicines in remote villages.",
            Hindi: "स्वास्थ्य सेवाएं:\nनि:शुल्क चिकित्सा शिविर और मोबाइल स्वास्थ्य इकाइयाँ।\nदूरस्थ गाँवों में आवश्यक दवाओं का वितरण।",
        },
        womenEmpowerment: {
            English: "Women Empowerment Programs:\nSkill development workshops for self-sufficiency.\nTraining sessions for women-led entrepreneurship.",
            Hindi: "महिला सशक्तिकरण कार्यक्रम:\nआत्मनिर्भरता के लिए कौशल विकास कार्यशालाएँ।\nमहिला नेतृत्व वाले उद्यमों के लिए प्रशिक्षण सत्र।",
        },
        agriculture: {
            English: "Agricultural Sustainability:\nOrganic farming training and technology adoption.\nSuccess stories of farmers benefiting from modern techniques.",
            Hindi: "कृषि स्थिरता:\nजैविक खेती का प्रशिक्षण और तकनीक अपनाने की प्रक्रिया।\nआधुनिक तकनीकों से लाभान्वित किसानों की सफलता की कहानियाँ।",
        },
        waterSanitation: {
            English: "Clean Water & Sanitation:\nInstallation of safe drinking water facilities.\nAwareness drives on hygiene and sanitation.",
            Hindi: "स्वच्छ जल एवं स्वच्छता:\nसुरक्षित पेयजल सुविधाओं की स्थापना।\nस्वच्छता और हाइजीन को लेकर जन जागरूकता अभियान।",
        },
        viewAll: {
            English: "View All",
            Hindi: "सभी देखें",
        },
    },

    agencyType: [
        { label: "सेक्शन 8", value: "section" },
        { label: "सोसायटी / ट्रस्ट", value: "society-trust" },
        { value: "autonomous-body", label: "वैधानिक निकाय" },
        { label: "डोनर फाउंडेशन", value: "donor-foundation" },
    ],

    FAQ: [
        {
            question: {
                English: "Which companies are required to undertake CSR?",
                Hindi: "कौन-कौन सी कंपनी पर CSR लागू होता है?"
            },
            answer: {
                English: "Any company that in the immediately preceding financial year, satisfies any one of the following criteria:\n• Net worth of ₹500 crore or more, or\n• Turnover of ₹1,000 crore or more, or\n• Net profit of ₹5 crore or more",
                Hindi: "वह कंपनी, जो तत्काल पूर्व वित्तीय वर्ष में निम्नलिखित में से किसी एक मानदंड को पूरा करती है:\n• नेट वर्थ ₹500 करोड़ या अधिक, या\n• टर्नओवर ₹1,000 करोड़ या अधिक, या\n• शुद्ध लाभ ₹5 करोड़ या अधिक"
            }
        },
        {
            question: {
                English: "What does 'any financial year' mean under Section 135?",
                Hindi: "धारा 135 में 'कोई भी वित्तीय वर्ष' का क्या अर्थ है?"
            },
            answer: {
                English: "It refers to the immediately preceding financial year. Earlier it referred to any of the previous three years which is no longer applicable.",
                Hindi: "अब इसका आशय तत्काल पूर्व वित्तीय वर्ष से है, न कि पिछले तीन वर्षों में से किसी एक से।"
            }
        },
        {
            question: {
                English: "Are Section 8 companies required to comply with CSR?",
                Hindi: "क्या धारा 8 कंपनी पर भी CSR लागू होता है?"
            },
            answer: {
                English: "Yes, if a Section 8 company meets the financial thresholds it is required to comply with CSR provisions.",
                Hindi: "हाँ, यदि धारा 8 (गैर-लाभकारी) कंपनी उपरोक्त वित्तीय मानदंडों को पूरा करती है, तो CSR नियम उस पर भी लागू होते हैं।"
            }
        },
        {
            question: {
                English: "Do holding or subsidiary companies have CSR obligations?",
                Hindi: "क्या होल्डिंग या सब्सिडियरी कंपनी को CSR अनुपालन करना होगा?"
            },
            answer: {
                English: "CSR obligations are company-specific. A holding or subsidiary company must comply only if it independently meets the CSR eligibility criteria.",
                Hindi: "CSR कंपनी-विशिष्ट है। होल्डिंग या सब्सिडियरी कंपनी पर CSR तभी लागू होगा जब वह स्वयं उपरोक्त योग्यता को पूरा करे।"
            }
        },
        {
            question: {
                English: "Do newly incorporated companies have to comply with CSR provisions?",
                Hindi: "क्या नई कंपनी पर भी CSR लागू होता है?"
            },
            answer: {
                English: "Yes. If a newly incorporated company meets the eligibility in the immediately preceding financial year, CSR obligations apply even if it has not completed three years.",
                Hindi: "हाँ, यदि कोई नई कंपनी किसी भी तत्काल पूर्व वर्ष में योग्यता को पूरा करती है, तो उस पर CSR लागू होगा, भले ही 3 वर्ष पूरे न हुए हों।"
            }
        },
        {
            question: {
                English: "How is the average net profit for CSR calculated?",
                Hindi: "CSR के लिए औसत शुद्ध लाभ की गणना कैसे की जाती है?"
            },
            answer: {
                English: "Average net profit is calculated based on Section 198 of the Companies Act. It refers to net profit before tax, excluding certain items like capital gains, revaluation reserves, etc.",
                Hindi: "धारा 198 के अनुसार, कर पूर्व शुद्ध लाभ (Net Profit before Tax) के आधार पर औसत निकाला जाता है। कुछ विशिष्ट मदों को इसमें से बाहर रखा जाता है।"
            }
        },
        {
            question: {
                English: "What are the responsibilities of the Board of Directors under CSR?",
                Hindi: "CSR के तहत निदेशक मंडल की क्या जिम्मेदारियाँ हैं?"
            },
            answer: {
                English: "• Approve and disclose the CSR policy\n• Monitor implementation of projects\n• Spend at least 2% of average net profit of last three years on CSR\n• Report reasons for unspent amounts in board report and transfer such amount to specified funds",
                Hindi: "• CSR नीति को स्वीकृति देना और सार्वजनिक रूप से प्रकट करना\n• परियोजनाओं की निगरानी करना\n• पिछले तीन वर्षों के औसत शुद्ध लाभ का कम से कम 2% CSR पर व्यय करना\n• यदि व्यय नहीं हुआ है तो कारणों सहित बोर्ड रिपोर्ट में उल्लेख करना और राशि को उपयुक्त कोष में स्थानांतरित करना"
            }
        },
        {
            question: {
                English: "What is the role of CSR Committee?",
                Hindi: "CSR समिति की भूमिका क्या है?"
            },
            answer: {
                English: "Where applicable, CSR Committee must:\n• Formulate CSR policy and action plan\n• Recommend projects\n• Monitor implementation and outcomes of projects",
                Hindi: "जहाँ लागू हो, CSR समिति को:\n• CSR नीति और वार्षिक कियान्वयन योजना बनानी होती है\n• बजट आवंटित करना होता है\n• परियोजनाओं के कार्यान्वयन और परिणाम की निगरानी करनी होती है"
            }
        },
        {
            question: {
                English: "What is the limit for administrative overheads under CSR?",
                Hindi: "CSR के तहत प्रशासनिक व्यय की सीमा क्या है?"
            },
            answer: {
                English: "CSR administrative expenses should not exceed 5% of total CSR expenditure.",
                Hindi: "CSR प्रशासनिक व्यय कुल CSR व्यय का 5% से अधिक नहीं होना चाहिए।"
            }
        },
        {
            question: {
                English: "What is the limit for impact assessment expenditure?",
                Hindi: "प्रभाव आकलन (Impact Assessment) व्यय की सीमा क्या है?"
            },
            answer: {
                English: "For CSR projects with outlays of ₹1 crore or more, impact assessment is mandatory. Expenditure on such assessment can be up to 2% of total CSR expenditure or ₹50 lakh, whichever is higher.",
                Hindi: "CSR परियोजनाओं में, यदि बजट ₹1 करोड़ या उससे अधिक है, तो प्रभाव आकलन आवश्यक है। इस पर कुल CSR व्यय का 2% या ₹50 लाख, इनमें से जो अधिक हो, व्यय किया जा सकता है।"
            }
        },
        {
            question: {
                English: "What activities qualify under CSR?",
                Hindi: "कौन-कौन सी गतिविधियाँ CSR के अंतर्गत आती हैं?"
            },
            answer: {
                English: "CSR activities must fall under Schedule VII, such as:\n• Education\n• Healthcare\n• Environmental protection\n• Rural development\n• Gender equality\n• Art, culture and heritage\n• Disaster relief etc.",
                Hindi: "CSR गतिविधियाँ अनुसूची VII के तहत होनी चाहिए, जैसे:\n• शिक्षा\n• स्वास्थ्य सेवा\n• पर्यावरण संरक्षण\n• ग्रामीण विकास\n• लैंगिक समानता\n• कला, संस्कृति एवं विरासत\n• आपदा राहत आदि"
            }
        },
        {
            question: {
                English: "Is disaster relief included in CSR?",
                Hindi: "क्या आपदा राहत CSR में शामिल है?"
            },
            answer: {
                English: "Yes. Examples include:\n• Medical assistance\n• Food and nutrition\n• Clean drinking water\nThese are covered under Schedule VII.",
                Hindi: "हाँ। जैसे:\n• चिकित्सकीय सहायता\n• खाद्य एवं पोषण\n• स्वच्छ पेयजल\nअनुसूची VII के अंतर्गत CSR में मान्य हैं।"
            }
        },
        {
            question: {
                English: "Are in-kind contributions allowed under CSR?",
                Hindi: "क्या CSR के अंतर्गत वस्तुओं (In-kind) का योगदान मान्य है?"
            },
            answer: {
                English: "No. Only monetary expenditure is recognized under CSR. Contributions in the form of goods or services are not counted.",
                Hindi: "नहीं। CSR के तहत केवल वित्तीय व्यय मान्य है। वस्तुओं या सेवाओं के रूप में दिया गया योगदान मान्य नहीं है।"
            }
        },
        {
            question: {
                English: "Can CSR funds be used to support government schemes?",
                Hindi: "क्या CSR फंड से सरकारी योजनाओं को समर्थन दिया जा सकता है?"
            },
            answer: {
                English: "CSR should not substitute government spending. However, independent support to public infrastructure or services aligned with Schedule VII is permitted.",
                Hindi: "CSR का उद्देश्य सरकारी व्यय की पूर्ति नहीं है। फिर भी, यदि कोई गतिविधि अनुसूची VII के अंतर्गत आती है, तो उसका स्वतंत्र समर्थन CSR के तहत किया जा सकता है।"
            }
        },
        {
            question: {
                English: "What is Form CSR-1?",
                Hindi: "CSR-1 फॉर्म क्या है?"
            },
            answer: {
                English: "Form CSR-1 is mandatory registration for all entities (NGOs, Trusts, Section 8 companies) seeking to receive CSR funds. It must be filed before accepting any CSR contribution.",
                Hindi: "CSR-1 फॉर्म उन सभी संस्थाओं (NGO, ट्रस्ट, धारा 8 कंपनी) के लिए अनिवार्य है जो CSR फंड प्राप्त करना चाहती हैं। इसे दान प्राप्त करने से पहले दाखिल करना आवश्यक है।"
            }
        },
        {
            question: {
                English: "Is CSR expenditure tax deductible?",
                Hindi: "क्या CSR व्यय को कर योग्य व्यय माना जाता है?"
            },
            answer: {
                English: "No. CSR expenditure is not considered as business expenditure under the Income Tax Act.",
                Hindi: "नहीं। CSR व्यय आयकर अधिनियम के तहत व्यावसायिक व्यय नहीं माना जाता।"
            }
        }
    ],

    dashboardFyear: {
        "FY 2023–24": {
            summary: [
                {
                    value: { English: '260.53', Hindi: '260.53' },
                    label: { English: 'CSR Expenditure in Total', Hindi: 'सीएसआर कुल व्यय' }
                },
                {
                    value: { English: '325', Hindi: '325' },
                    label: { English: 'Total Companies', Hindi: 'कुल कंपनियाँ' }
                },
                {
                    value: { English: '38', Hindi: '38' },
                    label: { English: 'Total Districts', Hindi: 'कुल जिले' }
                },
                {
                    value: { English: 'Muzaffarpur', Hindi: 'मुज़फ्फरपुर' },
                    label: { English: 'Top District', Hindi: 'शीर्ष जिला' }
                },
                {
                    value: { English: '9', Hindi: '9' },
                    label: { English: 'Total Sectors', Hindi: 'कुल क्षेत्र' }
                }
            ],
            sectorWise: [
                {
                    name: {
                        English: "Health, Eradicating Hunger, Poverty and Malnutrition, Safe Drinking water, Sanitation ", Hindi: "स्वास्थ्य, भूख, गरीबी और कुपोषण उन्मूलन, सुरक्षित पेयजल, स्वच्छता"
                    },
                    value: 110,
                },
                { name: { English: "Education, Differently Abled, livelihood", Hindi: "शिक्षा, दिव्यांग, आजीविका" }, value: 83.97 },
                { name: { English: "Rural Development", Hindi: "ग्रामीण विकास" }, value: 38.08 },
                {
                    name: { English: "Environment, Animal Welfare, Conservation of Resources", Hindi: "पर्यावरण, पशु कल्याण, संसाधनों का संरक्षण" },
                    value: 21.23,
                },
                {
                    name: { English: "Gender Equality, Women Empowerment, Old Age Homes, Reducing Inequalities", Hindi: "लैंगिक समानता, महिला सशक्तिकरण, वृद्धाश्रम, असमानताओं को कम करना" },
                    value: 4.36,
                },
                { name: { English: "Encouraging Sports", Hindi: "खेल को प्रोत्साहन" }, value: 1.05 },
                { name: { English: "Heritage Art And Culture", Hindi: "विरासत कला और संस्कृति" }, value: 0.9 },
                { name: { English: "Others", Hindi: "अन्य" }, value: 0.8 },
                {
                    name: { English: "Other Sectors (Technology Incubator And benefits To Armed Forces And Admin Overheads)", Hindi: "अन्य क्षेत्र (प्रौद्योगिकी इन्क्यूबेटर और सशस्त्र बलों का लाभ और प्रशासनिक व्यय)" },
                    value: 0.14,
                },
            ],
            distinct: [
                { name: { English: "Muzaffarpur", Hindi: "मुजफ्फरपुर" }, amount: 52 },
                { name: { English: "Patna", Hindi: "पटना" }, amount: 38.72 },
                { name: { English: "Begusarai", Hindi: "बेगूसराय" }, amount: 20.09 },
                { name: { English: "Bhojpur", Hindi: "भोजपुर" }, amount: 19.31 },
                { name: { English: "Gaya", Hindi: "गया" }, amount: 13.51 },
                { name: { English: "Bhagalpur", Hindi: "भागलपुर" }, amount: 12.86 },
                { name: { English: "Darbhanga", Hindi: "दरभंगा" }, amount: 10.69 },
                { name: { English: "Aurangabad", Hindi: "औरंगाबाद" }, amount: 10.63 },
                { name: { English: "Jehnabad", Hindi: "जहानाबाद" }, amount: 8.49 },
                { name: { English: "Samastipur", Hindi: "समस्तीपुर" }, amount: 7.33 },
            ],
            companyWise: [
                { name: { English: "Alkem Laboratories Limited", Hindi: "अल्केम लैबोरेटरीज़ लिमिटेड" }, amount: 27.26 },
                { name: { English: "NTPC Limited", Hindi: "एनटीपीसी लिमिटेड" }, amount: 24.1 },
                { name: { English: "Indian Oil Corporation Ltd.", Hindi: "इंडियन ऑयल कॉर्पोरेशन लिमिटेड" }, amount: 21.25 },
                { name: { English: "Wipro Limited", Hindi: "विप्रो लिमिटेड" }, amount: 17.42 },
                { name: { English: "HDFC Bank Limited", Hindi: "एचडीएफसी बैंक लिमिटेड" }, amount: 16.13 },
                { name: { English: "Rec Limited", Hindi: "आरईसी लिमिटेड" }, amount: 14.33 },
                { name: { English: "Industrial Bank Ltd", Hindi: "इंडस्ट्रियल बैंक लिमिटेड" }, amount: 12.33 },
                { name: { English: "Accenture Solution Pvt Liited", Hindi: "एक्सेंचर सॉल्यूशन प्राइवेट लिमिटेड" }, amount: 8.55 },
                { name: { English: "Dr Reddy'S Laboratories Ltd", Hindi: "डॉ. रेड्डीज़ लैबोरेटरीज़ लिमिटेड" }, amount: 6.3 },
                { name: { English: "Hindustan Unilever Ltd", Hindi: "हिंदुस्तान यूनिलीवर लिमिटेड" }, amount: 5.59 },
            ],
        },
        "FY 2022–23": {
            summary: [
                {
                    value: { English: "241.41", Hindi: "241.41" },
                    label: { English: "CSR Expenditure in Total", Hindi: "सीएसआर कुल व्यय" }
                },
                {
                    value: { English: "297", Hindi: "297" },
                    label: { English: "Total Companies", Hindi: "कुल कंपनियाँ" }
                },
                {
                    value: { English: "38", Hindi: "38" },
                    label: { English: "Total Districts", Hindi: "कुल जिले" }
                },
                {
                    value: { English: "Kishanganj", Hindi: "किशनगंज" },
                    label: { English: "Top District", Hindi: "शीर्ष जिला" }
                },
                {
                    value: { English: "8", Hindi: "8" },
                    label: { English: "Total Sectors", Hindi: "कुल क्षेत्र" }
                }
            ],
            sectorWise: [
                {
                    name: { English: "Health, Eradicating Hunger, Poverty and Malnutrition, Safe Drinking water, Sanitation ", Hindi: "स्वास्थ्य, भूख, गरीबी और कुपोषण उन्मूलन, सुरक्षित पेयजल, स्वच्छता" },
                    value: 133.48,
                },
                { name: { English: "Education, Differently Abled, livelihood", Hindi: "शिक्षा, दिव्यांग, आजीविका" }, value: 63.81 },
                { name: { English: "Rural Development", Hindi: "ग्रामीण विकास" }, value: 30.42 },
                {
                    name: { English: "Environment, Animal Welfare, Conservation of Resources", Hindi: "पर्यावरण, पशु कल्याण, संसाधनों का संरक्षण" },
                    value: 7.44,
                },
                { name: { English: "Encouraging Sports", Hindi: "खेल को प्रोत्साहन" }, value: 3.74 },
                { name: { English: "Heritage Art And Culture", Hindi: "विरासत कला और संस्कृति" }, value: 1.33 },
                {
                    name: { English: " Gender Equality, Women Empowerment, Old Age Homes, Reducing Inequalities", Hindi: "लैंगिक समानता, महिला सशक्तिकरण, वृद्धाश्रम, असमानताओं को कम करना" },
                    value: 1.18,
                },
                {
                    name: { English: "Other Sectors (Technology Incubator And benefits To Armed Forces And Admin Overheads)", Hindi: "अन्य क्षेत्र (प्रौद्योगिकी इन्क्यूबेटर और सशस्त्र बलों का लाभ और प्रशासनिक व्यय)" },
                    value: 0.01,
                },
            ],
            distinct: [
                { name: { English: "Kisanganj", Hindi: "किशनगंज" }, amount: 38.36 },
                { name: { English: "Patna", Hindi: "पटना" }, amount: 27.17 },
                { name: { English: "Begusarai", Hindi: "बेगूसराय" }, amount: 18.11 },
                { name: { English: "Bhojpur", Hindi: "भोजपुर" }, amount: 12.81 },
                { name: { English: "Purnia", Hindi: "पूर्णिया" }, amount: 12.1 },
                { name: { English: "Darbhanga", Hindi: "दरभंगा" }, amount: 12.6 },
                { name: { English: "Aurangabad", Hindi: "औरंगाबाद" }, amount: 12.04 },
                { name: { English: "Saran", Hindi: "सारण" }, amount: 10.92 },
                { name: { English: "Muzaffarpur", Hindi: "मुजफ्फरपुर" }, amount: 10.09 },
                { name: { English: "Bhagalpur", Hindi: "भागलपुर" }, amount: 9.01 },
            ],
            companyWise: [
                { name: { English: "Power Grid Corporation of India Limited", Hindi: "पावर ग्रिड कॉर्पोरेशन ऑफ इंडिया लिमिटेड" }, amount: 45.45 },
                { name: { English: "NTPC Limited", Hindi: "एनटीपीसी लिमिटेड" }, amount: 37.48 },
                { name: { English: "HDFC Bank Limited", Hindi: "एचडीएफसी बैंक लिमिटेड" }, amount: 16.73 },
                { name: { English: "Atc Telecom Infrastructure Private Limited", Hindi: "एटीसी टेलीकॉम इंफ्रास्ट्रक्चर प्राइवेट लिमिटेड" }, amount: 11.01 },
                { name: { English: "Industrial Bank Ltd", Hindi: "इंडस्ट्रियल बैंक लिमिटेड" }, amount: 10 },
                { name: { English: "Icici Lombard General Insurance Company Ltd", Hindi: "आईसीआईसीआई लोम्बार्ड जनरल इंश्योरेंस कंपनी लिमिटेड" }, amount: 7.81 },
                { name: { English: "Dr Reddy'S Laboratories Ltd.", Hindi: "डॉ. रेड्डीज़ लैबोरेटरीज़ लिमिटेड" }, amount: 6.6 },
                { name: { English: "Rec Limited", Hindi: "आरईसी लिमिटेड" }, amount: 6.37 },
                { name: { English: "Indian Oil Corporation Ltd", Hindi: "इंडियन ऑयल कॉर्पोरेशन लिमिटेड" }, amount: 5.7 },
                { name: { English: "Aditya Birla Finance Ltd", Hindi: "आदित्य बिड़ला फाइनेंस लिमिटेड" }, amount: 5.6 },
            ],
        },
        "FY 2021–22": {
            summary: [
                {
                    value: { English: "178.97", Hindi: "178.97" },
                    label: { English: "CSR Expenditure in Total", Hindi: "सीएसआर कुल व्यय" }
                },
                {
                    value: { English: "232", Hindi: "232" },
                    label: { English: "Total Companies", Hindi: "कुल कंपनियाँ" }
                },
                {
                    value: { English: "38", Hindi: "38" },
                    label: { English: "Total Districts", Hindi: "कुल जिले" }
                },
                {
                    value: { English: "Pashchim Champaran", Hindi: "पश्चिम चंपारण" },
                    label: { English: "Top District", Hindi: "शीर्ष जिला" }
                },
                {
                    value: { English: "9", Hindi: "9" },
                    label: { English: "Total Sectors", Hindi: "कुल क्षेत्र" }
                }
            ],

            sectorWise: [
                {
                    name: { English: "Health, Eradicating Hunger, Poverty and Malnutrition, Safe Drinking water, Sanitation ", Hindi: "स्वास्थ्य, भूख, गरीबी और कुपोषण उन्मूलन, सुरक्षित पेयजल, स्वच्छता" },
                    value: 73.79,
                },
                {
                    name: { English: "Gender Equality, Women Empowerment, Old Age Homes, Reducing Inequalities", Hindi: "लैंगिक समानता, महिला सशक्तिकरण, वृद्धाश्रम, असमानताओं को कम करना" },
                    value: 44.06,
                },
                { name: { English: "Education, Differently Abled, livelihood", Hindi: "शिक्षा, दिव्यांग, आजीविका" }, value: 38.27 },
                { name: "Rural Development", value: 15.46 },
                {
                    name: { English: "Environment, Animal Welfare, Conservation of Resources", Hindi: "पर्यावरण, पशु कल्याण, संसाधनों का संरक्षण" },
                    value: 5.69,
                },
                { name: { English: "Encouraging Sports", Hindi: "खेल को प्रोत्साहन" }, value: 1.26 },
                { name: { English: "Heritage Art And Culture", Hindi: "विरासत कला और संस्कृति" }, value: 0.3 },
                {
                    name: { English: "Other Sectors (Technology Incubator And benefits To Armed Forces And Admin Overheads)", Hindi: "अन्य क्षेत्र (प्रौद्योगिकी इन्क्यूबेटर और सशस्त्र बलों का लाभ और प्रशासनिक व्यय)" },
                    value: 0.1,
                },
                { name: { English: "Slum Area Development", Hindi: "झुग्गी बस्ती विकास" }, value: 0.04 },
            ],
            distinct: [
                { name: { English: "West Champaran", Hindi: "पश्चिमी चंपारण" }, amount: 39.73 },
                { name: { English: "Patna", Hindi: "पटना" }, amount: 35.39 },
                { name: { English: "Muzaffarpur", Hindi: "मुजफ्फरपुर" }, amount: 9.83 },
                { name: { English: "Begusarai", Hindi: "बेगूसराय" }, amount: 8.9 },
                { name: { English: "Araria", Hindi: "अररिया" }, amount: 7.73 },
                { name: { English: "Samastipur", Hindi: "समस्तीपुर" }, amount: 6.15 },
                { name: { English: "Gaya", Hindi: "गया" }, amount: 6.11 },
                { name: { English: "Darbhanga", Hindi: "दरभंगा" }, amount: 5.4 },
                { name: { English: "Aurangabad", Hindi: "औरंगाबाद" }, amount: 4.64 },
                { name: { English: "Saran", Hindi: "सारण" }, amount: 3.75 },
            ],
            companyWise: [
                { name: { English: "Icici Bank Limited", Hindi: "आईसीआईसीआई लोम्बार्ड जनरल इंश्योरेंस कंपनी लिमिटेड" }, amount: 39.69 },
                { name: { English: "HDFC Bank Limited", Hindi: "एचडीएफसी बैंक लिमिटेड" }, amount: 12.87 },
                { name: { English: "Numaligarha Refinery Ltd", Hindi: "नुमालीगढ़ा रिफाइनरी लिमिटेड" }, amount: 10.82 },
                { name: { English: "Rec Limited", Hindi: "आरईसी लिमिटेड" }, amount: 8.09 },
                { name: { English: "Bihar State Power Transmission Company Limited", Hindi: "बिहार स्टेट पावर ट्रांसमिशन कंपनी लिमिटेड" }, amount: 7.4 },
                { name: { English: "Bayer CropScience Limited", Hindi: "बायर क्रॉपसाइंस लिमिटेड" }, amount: 7.27 },
                { name: { English: "Power Grid Corporation of India Limited", Hindi: "पावर ग्रिड कॉर्पोरेशन ऑफ इंडिया लिमिटेड" }, amount: 7.23 },
                { name: { English: "Nabinagar Power Generating Company Ltd", Hindi: "नबीनगर पावर जनरेटिंग कंपनी लिमिटेड" }, amount: 5.6 },
                { name: { English: "Dr Reddy'S Laboratories Ltd.", Hindi: "डॉ. रेड्डीज़ लैबोरेटरीज़ लिमिटेड" }, amount: 5.43 },
                { name: { English: "NTPC Limited", Hindi: "एनटीपीसी लिमिटेड" }, amount: 4.98 },
            ],
        },
    },


    diaLogues: {
        Event: {
            Maintitle: {
                English: "Upload Event Media",
                Hindi: "इवेंट मीडिया अपलोड करें"
            },
            uploadDoc: {
                English: "Upload Documents",
                Hindi: "दस्तावेज़ अपलोड करें"
            },
            docTitle: {
                English: "Document Title",
                Hindi: "दस्तावेज़ शीर्षक"
            },
            description: {
                English: "Document Description",
                Hindi: "दस्तावेज़ विवरण"
            },
            upload: {
                English: "Select Documents to Upload",
                Hindi: "अपलोड करने के लिए दस्तावेज़ चुनें"
            },
            enterEventDeleteComment: {
                English: "Enter Event Delete Comment *",
                Hindi: "कार्यक्रम हटाने की टिप्पणी दर्ज करें *"
            },
            submit: {
                English: "Upload",
                Hindi: "अपलोड करें"
            },
            confirmDeleteMessage: {
                English: "Are you really want to Delete?",
                Hindi: "क्या आप वाकई हटाना चाहते हैं?"
            },
            thisEventPermanently: {
                English: "this Event permanently",
                Hindi: "इस कार्यक्रम को स्थायी रूप से?"
            },
            errors: {
                titleRequired: {
                    English: "Title is required",
                    Hindi: "शीर्षक आवश्यक है"
                },
                descriptionRequired: {
                    English: "Description is required",
                    Hindi: "विवरण आवश्यक है"
                },
                uploadRequired: {
                    English: "Please upload at least one document",
                    Hindi: "कृपया कम से कम एक दस्तावेज़ अपलोड करें"
                }
            },

            Registration: {
                Title: {
                    English: "Register Event",
                    Hindi: "कार्यक्रम पंजीकरण करें"
                },
                fname: {
                    English: "First Name *",
                    Hindi: "पहला नाम *"
                },
                lastName: {
                    English: "Last Name *",
                    Hindi: "अंतिम नाम *"
                },
                mobileNumber: {
                    English: "Mobile Number *",
                    Hindi: "मोबाइल नंबर *"
                },
                email: {
                    English: "Email *",
                    Hindi: "ईमेल *"
                },
                address: {
                    English: "Address *",
                    Hindi: "पता *"
                },
                submit: {
                    English: "Submit",
                    Hindi: "जमा करें"
                },
                Errors: {

                    firstNameRequired: {
                        English: "First Name is Required",
                        Hindi: "पहला नाम आवश्यक है"
                    },
                    lastNameRequired: {
                        English: "Last Name is Required",
                        Hindi: "अंतिम नाम आवश्यक है"
                    },
                    mobileNumberRequired: {
                        English: "Mobile Number is Required",
                        Hindi: "मोबाइल नंबर आवश्यक है"
                    },
                    contactValidation: {
                        English: "Contact must be a 10-digit number",
                        Hindi: "संपर्क संख्या 10 अंकों की होनी चाहिए"
                    },
                    emailRequired: {
                        English: "Email is Required",
                        Hindi: "ईमेल आवश्यक है"
                    },
                    emailValidation: {
                        English: "Invalid email format",
                        Hindi: "अमान्य ईमेल प्रारूप"
                    },
                    addressRequired: {
                        English: "Address is Required",
                        Hindi: "पता आवश्यक है"
                    },
                    addressValidation: {
                        English: "Address must be at least 5 characters",
                        Hindi: "पता कम से कम 5 अक्षरों का होना चाहिए"
                    }
                }

            },
            publish: {
                mainTitle: {
                    English: "Are you want to publish this event?",
                    Hindi: "क्या आप इस कार्यक्रम को प्रकाशित करना चाहते हैं?"
                },
                publishEventConfirmation: {
                    English: "Are you really want to publish this Event?",
                    Hindi: "क्या आप वाकई इस कार्यक्रम को प्रकाशित करना चाहते हैं?"
                },
                enterEventPublishComment: {
                    English: "Enter Event Publish Comment *",
                    Hindi: "कार्यक्रम प्रकाशित टिप्पणी दर्ज करें *"
                },
                thisEvent: {
                    English: "this Event",
                    Hindi: "यह कार्यक्रम"
                },
                publish: {
                    English: "Publish",
                    Hindi: "प्रकाशित करें"
                },
                pleaseEnterPublishComment: {
                    English: "Please Enter Comment to Publish.!",
                    Hindi: "प्रकाशित करने के लिए कृपया टिप्पणी दर्ज करें.!"
                }

            }
        },

        role: {
            title: {
                English: "Assign Role",
                Hindi: "भूमिका सौंपें"
            },
            roleSelect: {
                English: "Select Role",
                Hindi: "भूमिका चुनें"
            },
            assign: {
                English: "Assign",
                Hindi: "सौंपें"
            },
            noRole: {
                English: "No role details available.",
                Hindi: "कोई भूमिका विवरण उपलब्ध नहीं है।"
            },
            assignment: {
                English: "Assign Permission For",
                Hindi: "के लिए अनुमति सौंपें"
            },
            close: {
                English: "Close",
                Hindi: "बंद करें"
            },
            submit: {
                English: "Submit",
                Hindi: "जमा करें"
            },
            delete: {
                English: "Are you sure you want to delete the role",
                Hindi: "क्या आप वाकई भूमिका को हटाना चाहते हैं"
            },
            delete1: {
                English: "Are you sure you want to delete the",
                Hindi: "क्या आप वाकई इसे हटाना चाहते हैं"
            },
            cancel: {
                English: "Cancel",
                Hindi: "रद्द करें"
            },
            yes: {
                English: "Yes",
                Hindi: "हाँ"
            },
            addPermission: {
                English: "Add Permission",
                Hindi: "अनुमति जोड़ें"
            },
            menuDelete: {
                English: "Are you sure you want to delete the menu",
                Hindi: "क्या आप वाकई मेनू को हटाना चाहते हैं"
            },
            addMenuForm: [
                { English: "Parent Menu", Hindi: "अभिभावक मेनू" },
                { English: "Name *", Hindi: "नाम *" },
                { English: "Name is required", Hindi: "नाम आवश्यक है" },
                { English: "URL *", Hindi: "यूआरएल *" },
                { English: "Icon *", Hindi: "आइकन *" },
                { English: "Icon is required", Hindi: "आइकन आवश्यक है" },
                { English: "Menu Order *", Hindi: "मेनू क्रम *" },
                { English: "Must be a number", Hindi: "संख्या होनी चाहिए" },
                { English: "Menu order is required", Hindi: "मेनू क्रम आवश्यक है" },
                { English: "Is Navigation", Hindi: "क्या यह नेविगेशन है" }
            ]

        }
    },
    projectCategories: [
        { English: "Education & Skill Development", Hindi: "शिक्षा और कौशल विकास" },
        { English: "Environment", Hindi: "पर्यावरण" },
        { English: "Healthcare", Hindi: "स्वास्थ्य देखभाल" },
        { English: "Sports", Hindi: "खेल" },
        { English: "National Heritage", Hindi: "राष्ट्रीय धरोहर" },
        { English: "Rural Development", Hindi: "ग्रामीण विकास" },
    ],

    commiteeLits: [
        {
            sr_no: "1",
            designation: { English: "Chairperson", Hindi: "अध्यक्ष" },
            department: { English: "Chief Secretary, .", Hindi: "मुख्य सचिव बिहार सरकार" }
        },
        {
            sr_no: "2",
            designation: { English: "Vice-Chairperson", Hindi: "उपाध्यक्ष" },
            department: { English: "Development Commissioner, .", Hindi: "विकास आयुक्त, बिहार सरकार" }
        },
        {
            sr_no: "3",
            designation: { English: "Member Secretary", Hindi: "सदस्य सचिव" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary,Finance Department, ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, वित्त विभाग" }
        },
        {
            sr_no: "4",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Health Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, स्वास्थ्य विभाग" }
        },
        {
            sr_no: "5",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary,Education Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, शिक्षा विभाग" }
        },
        {
            sr_no: "6",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Road Construction Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, पथ निर्माण विभाग" }
        },
        {
            sr_no: "7",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Rural Works Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, ग्रामीण कार्य विभाग" }
        },
        {
            sr_no: "8",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Department of Industries, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, उद्योग विभाग " }
        },
        {
            sr_no: "9",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Environment, Forest & Climate Change Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, पर्यावरण, वन एवं जलवायु परिवर्तन विभाग" }
        },
        {
            sr_no: "10",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/ Secretary, Animal & Fisheries Resources Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, पशु एवं मत्स्य संसाधन विभाग" }
        },
        {
            sr_no: "11",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Planning and Development Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, योजना एवं विकास विभाग " }
        },
        {
            sr_no: "12",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Water Resources Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, जल संसाधन विभाग" }
        },
        {
            sr_no: "13",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Public Health Engineering Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, लोक स्वास्थ्य अभियंत्रण विभाग" }
        },
        {
            sr_no: "14",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Social Welfare Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, समाज कल्याण विभाग" }
        },
        {
            sr_no: "15",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Urban Development & Housing Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, नगर विकास एवं आवास विभाग" }
        },
        {
            sr_no: "16",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Agriculture Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, कृषि विभाग " }
        },
        {
            sr_no: "17",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Rural Development Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, ग्रामीण विकास विभाग" }
        },
        {
            sr_no: "18",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Art, Culture & Youth Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, कला, संस्कृति एवं युवा विभाग" }
        },
        {
            sr_no: "19",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Building Construction Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, भवन निर्माण विभाग " }
        },
        {
            sr_no: "20",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Energy Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, ऊर्जा विभाग" }
        },
        {
            sr_no: "21",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Tourism Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, पर्यटन विभाग" }
        },
        {
            sr_no: "22",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Commercial Tax Department, . ", Hindi: "आयुक्त-सह-सचिव, वाणिज्य कर विभाग" }
        },
        {
            sr_no: "23",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, SC & ST Welfare Department, .", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, अनुसूचित जाति एवं जनजाति कल्याण विभाग" }
        },
        {
            sr_no: "24",
            designation: { English: "Member", Hindi: "सदस्य" },
            department: { English: "Additional Chief Secretary/Principal Secretary/Secretary, Labour Resources Department, . ", Hindi: "अपर मुख्य सचिव / प्रधान सचिव / सचिव, श्रम संसाधन विभाग" }
        }
    ],

    Menupermissions: [
        {
            "id": 2,
            "name": { "English": "Admin Dashboard", "Hindi": "एडमिन डैशबोर्ड" },
        },
        {
            "id": 47,
            "name": { "English": "Masters", "Hindi": "मास्टर्स" },
            "sub_menus": [
                {
                    "id": 41,
                    "name": { "English": "Roles", "Hindi": "भूमिकाएं" },
                },
                {
                    "id": 43,
                    "name": { "English": "Menus", "Hindi": "मेनू" }
                },
                {
                    "id": 83,
                    "name": { "English": "Themes", "Hindi": "थीम्स" }
                },
                {
                    "id": 79,
                    "name": { "English": "Sewa Master", "Hindi": "सेवा मास्टर" }
                },
                {
                    "id": 46,
                    "name": { "English": "Workflow", "Hindi": "कार्य प्रवाह" },
                }
            ]
        },
        {
            "id": 1,
            "name": { "English": "Registrations", "Hindi": "पंजीकरण" },
            "sub_menus": [
                {
                    "id": 38,
                    "name": { "English": "All Users", "Hindi": "सभी उपयोगकर्ता" },
                },
                {
                    "id": 31,
                    "name": { "English": "CSR Partner", "Hindi": "सीएसआर भागीदार" }
                },
                {
                    "id": 32,
                    "name": { "English": "NGO", "Hindi": "कार्यान्वयन" },
                },
                {
                    "id": 80,
                    "name": { "English": "Volunteer", "Hindi": "स्वयंसेवक" }
                },
                {
                    "id": 81,
                    "name": { "English": "CSR Cell", "Hindi": "सीएसआर प्रकोष्ठ" }
                },
                {
                    "id": 33,
                    "name": { "English": "Society Members", "Hindi": "समिति सदस्य" },
                }
            ]
        },
        {
            "id": 3,
            "name": { "English": "CSR Projects", "Hindi": "सीएसआर परियोजनाएं" },
            "sub_menus": [
                {
                    "id": 39,
                    "name": { "English": "All Projects", "Hindi": "सभी परियोजनाएं" },
                },
                {
                    "id": 53,
                    "name": { "English": "Completed / Ongoing", "Hindi": "पूर्ण / प्रगति पर" },
                },
                {
                    "id": 63,
                    "name": { "English": "All Commitment", "Hindi": "सभी प्रतिबद्धताएं" },
                },
                {
                    "id": 34,
                    "name": { "English": "My Projects", "Hindi": "मेरी परियोजनाएं" },
                },
                {
                    "id": 35,
                    "name": { "English": "My Interested Projects", "Hindi": "मेरी इच्छुक परियोजनाएं" },
                },
                {
                    "id": 71,
                    "name": { "English": "Projects for Donors", "Hindi": "दानदाताओं के लिए परियोजनाएं" },
                },
                {
                    "id": 72,
                    "name": { "English": "My Commitment", "Hindi": "मेरी प्रतिबद्धता" },
                },
                {
                    "id": 66,
                    "name": { "English": "Projects for NGO", "Hindi": "एजेंसियों के लिए परियोजनाएं" },
                },
            ]
        },
        {
            "id": 40,
            "name": { "English": "NGO", "Hindi": "कार्यान्वयन एजेंसियां" },
            "sub_menus": [
                {
                    "id": 61,
                    "name": { "English": "Approved NGO", "Hindi": "स्वीकृत एजेंसियां" },
                },
                {
                    "id": 52,
                    "name": { "English": "Mapping of IA-Projects", "Hindi": "आईए-परियोजनाओं का मानचित्रण" },
                }
            ]
        },
        {
            "id": 49,
            "name": { "English": "Financial Management", "Hindi": "वित्तीय प्रबंधन" },
            "sub_menus": [
                {
                    "id": 64,
                    "name": { "English": "Fund Disbursement & Utilization", "Hindi": "निधि वितरण और उपयोग" },
                },
                {
                    "id": 65,
                    "name": { "English": "Financial Management Overview", "Hindi": "वित्तीय प्रबंधन अवलोकन" },
                }
            ]
        },
        {
            "id": 14,
            "name": { "English": "Tender", "Hindi": "निविदा" },
        },
        {
            "id": 12,
            "name": { "English": "Knowledge Base", "Hindi": "ज्ञान आधार" },
        },
        {
            "id": 13,
            "name": { "English": "Event and Media", "Hindi": "इवेंट और मीडिया" },
        },
        {
            "id": 15,
            "name": { "English": "CSR Society", "Hindi": "सीएसआर समिति" },
        }
    ],
    loginOptions: [
        {
            English: 'User Profile', Hindi: 'उपयोगकर्ता रूपरेखा'
        },
        {
            English: 'Change Password', Hindi: 'पासवर्ड बदलें'
        },
        {
            English: "Old Password ", Hindi: "पुराना पासवर्ड ",
        },
        {
            English: "New Password ", Hindi: "नया पासवर्ड ",
        },
        {
            English: "Confirm Password", Hindi: "पासवर्ड की पुष्टि करें ",
        },

        {
            English: 'Logout', Hindi: 'लॉग आउट'
        },
        {
            English: "Old password must be at least 8 characters", Hindi: "पुराना पासवर्ड कम से कम 8 अक्षरों का होना चाहिए"
        },
        {
            English: "Old password is required", Hindi: "पुराना पासवर्ड आवश्यक है"
        },
        {
            English: "New password must be at least 8 characters", Hindi: "नया पासवर्ड कम से कम 8 अक्षरों का होना चाहिए"
        },
        {
            English: "New password is required", Hindi: "नया  पासवर्ड आवश्यक है"
        },

        {
            English: "New password must contain at least one uppercase letter, one lowercase letter, one number, and one special character", Hindi: "नए पासवर्ड में कम से कम एक बड़ा अक्षर, एक छोटा अक्षर, एक संख्या और एक विशेष अक्षर होना चाहिए"
        },
        {
            English: "Confirm password is required", Hindi: "पासवर्ड की पुष्टि आवश्यक है"
        },
        {
            English: "Passwords must match the new password", Hindi: "पासवर्ड नए पासवर्ड से मेल खाना चाहिए"
        },
        {
            English: "CAPTCHA Verification", Hindi: "कैप्चा सत्यापन"
        },
        {
            English: "Enter Captcha", Hindi: "कैप्चा दर्ज करें"
        },
        {
            English: "Please complete the captcha", Hindi: "कृपया कैप्चा पूरा करें"
        },
    ],

    fundDisbUtilise: [
        { English: "Fund Disbursed", Hindi: "वितरित निधि" },
        { English: "Fund Utilized", Hindi: "निधि का उपयोग" },
        { English: "Assign Agency", Hindi: "एजेंसी नियुक्त करें" },
        { English: "Project Name", Hindi: "परियोजना का नाम" },
        { English: "NGO", Hindi: "कार्यान्वयन एजेंसी" },
        { English: "Utilization Date", Hindi: "उपयोग तिथि" },
        { English: "Utilized Amount", Hindi: "उपयोग की गई राशि" },
        { English: "Utilization Type", Hindi: "उपयोग प्रकार" },
        { English: "Upload Utilization Document", Hindi: "उपयोग दस्तावेज़ अपलोड करें" },
        { English: "Submit", Hindi: "जमा करें" },
        { English: "Fund Allocated", Hindi: "आवंटित निधि" },
        { English: "Remaining", Hindi: "शेष" },
        { English: "Fund Disbursement", Hindi: "निधि वितरण" },
        { English: "No Permission", Hindi: "अनुमति नहीं है" },
        { English: "Date is required", Hindi: " तिथि आवश्यक है" },
        { English: "Amount is required", Hindi: "राशि आवश्यक है" },
        { English: "Amount must be positive", Hindi: "राशि सकारात्मक होनी चाहिए" },
        { English: "Amount can't be greater than", Hindi: "राशि इससे अधिक नहीं हो सकती" },
        { English: "Please select utilization type", Hindi: "कृपया उपयोग का प्रकार चुनें" },
        { English: "Enter Remarks", Hindi: "टिप्पणियाँ दर्ज करें" },
        { English: "Upload Utilization Document", Hindi: "उपयोग दस्तावेज़ अपलोड करें" },
        { English: "UTR No is required", Hindi: "यूटीआर संख्या आवश्यक है" },
        { English: "UTR number must be between 9 and 22 digits", Hindi: "यूटीआर संख्या 9 से 22 अंकों के बीच होनी चाहिए" },
        { English: "Please select a payment mode", Hindi: "कृपया भुगतान का तरीका चुनें" },
        { English: "Attachment is required", Hindi: "संलग्नक आवश्यक है" }
    ],

    helpSupport: [
        {
            English: 'Help & Support', Hindi: 'सहायता और समर्थन'
        },
        {
            English: "We're here to assist you !", Hindi: 'हम आपकी सहायता के लिए यहां हैं'
        },
        {
            English: "Email us", Hindi: 'हमें ईमेल करें'
        },
        {
            English: "Send us an email at", Hindi: 'हमें ईमेल भेजें'
        },
        {
            English: " and we’ll respond within 24 hours.", Hindi: 'और हम 24 घंटे के भीतर जवाब देंगे.'
        },
    ],

    ABOUT_US_MENU: [
        {
            label: { English: "About Ashram", Hindi: "आश्रम के बारे में" },
            path: "/about-us",
        },
        {
            label: { English: "Our Team", Hindi: "हमारी टीम" },
            path: "/our-team",
        },
    ],
    Our_Team_Names: [
        {
            English: {
                name: 'Sri. Mukesh Kumar Lal, IAAS',
                post: 'Special Secretary',
                department: 'Finance Department',
                cum: 'cum – Chief Executive Officer,',
                state: 'Bihar State Corporate Social Responsibility Society'
            },
            Hindi: {
                name: 'श्री. मुकेश कुमार लाल, आई.ए.ए.एस',
                post: 'विशेष सचिव,',
                department: 'वित्त विभाग',
                cum: 'सह-मुख्य कार्यकारी अधिकारी,',
                state: 'बिहार राज्य कॉर्पोरेट सोशल रिस्पॉन्सिबिलिटी सोसाइटी'
            }
        }
    ],


    ashramAbout1: {
        English:
            "Guruji Ashram Society is dedicated to spreading spiritual awareness, meditation practices, and Vedic knowledge for the upliftment of humanity. The society works towards inner transformation, self-realization, and universal harmony through spiritual discipline and seva.",
        Hindi:
            "गुरुजी आश्रम सोसायटी मानवता के उत्थान के लिए आध्यात्मिक जागरूकता, ध्यान अभ्यास और वैदिक ज्ञान के प्रसार के लिए समर्पित है। यह संस्था आध्यात्मिक अनुशासन और सेवा के माध्यम से आंतरिक परिवर्तन, आत्म-साक्षात्कार और सार्वभौमिक सद्भाव की दिशा में कार्य करती है।",
    },

    ashramAbout2: {
        English:
            "The ashram provides a sacred environment for seekers to practice meditation, participate in spiritual rituals, and learn timeless spiritual knowledge rooted in ancient traditions.",
        Hindi:
            "आश्रम साधकों को ध्यान अभ्यास, आध्यात्मिक अनुष्ठानों में भाग लेने और प्राचीन परंपराओं पर आधारित सनातन आध्यात्मिक ज्ञान सीखने के लिए एक पवित्र वातावरण प्रदान करता है।",
    },

    /* ================= MISSION / VISION ================= */

    visionTitle: {
        English: "Vision",
        Hindi: "दृष्टि",
    },

    visionDesc: {
        English:
            "To uplift humanity through spiritual awakening and Vedic wisdom.",
        Hindi:
            "आध्यात्मिक जागृति और वैदिक ज्ञान के माध्यम से मानवता का उत्थान करना।",
    },

    missionTitle: {
        English: "Mission",
        Hindi: "मिशन",
    },

    missionDesc: {
        English:
            "To promote meditation, spiritual discipline, and universal compassion.",
        Hindi:
            "ध्यान, आध्यात्मिक अनुशासन और सार्वभौमिक करुणा को बढ़ावा देना।",
    },

    globalTitle: {
        English: "Global Outreach",
        Hindi: "वैश्विक विस्तार",
    },

    globalDesc: {
        English:
            "To build a global spiritual community beyond geographical and cultural boundaries.",
        Hindi:
            "भौगोलिक और सांस्कृतिक सीमाओं से परे एक वैश्विक आध्यात्मिक समुदाय का निर्माण करना।",
    },

    /* ================= GEOGRAPHICAL PRESENCE ================= */

    geoPresence: {
        English: "Geographical Presence",
        Hindi: "भौगोलिक उपस्थिति",
    },

    geoPresenceDesc: {
        English:
            "The primary spiritual headquarters is located in Tirupati, Andhra Pradesh, India. The ashram serves as the core center for meditation programs, spiritual learning, and seeker transformation.",
        Hindi:
            "मुख्य आध्यात्मिक मुख्यालय तिरुपति, आंध्र प्रदेश, भारत में स्थित है। यह आश्रम ध्यान कार्यक्रमों, आध्यात्मिक शिक्षा और साधकों के आध्यात्मिक विकास का मुख्य केंद्र है।",
    },

    geoPresenceDesc2: {
        English:
            "The spiritual mission extends globally through spiritual events, awareness programs, and international seeker communities.",
        Hindi:
            "आध्यात्मिक मिशन वैश्विक स्तर पर आध्यात्मिक कार्यक्रमों, जागरूकता अभियानों और अंतरराष्ट्रीय साधक समुदायों के माध्यम से फैल रहा है।",
    },

    /* ================= PHOTOS ================= */

    photos: {
        English: "Photos",
        Hindi: "फोटो",
    },

    /* ================= MENU MASTER DROPDOWN ================= */

    MenuMasterDropdown: {
        quickNavigate: {
            English: "Quick navigate",
            Hindi: "त्वरित नेविगेट करें",
        },
        now: {
            English: "Now",
            Hindi: "अभी",
        },
        quickNavigation: {
            English: "Quick Navigation",
            Hindi: "त्वरित नेविगेशन",
        },
        itemsSuffix: {
            English: "items",
            Hindi: "आइटम",
        },
        modulesAvailableSuffix: {
            English: "modules available",
            Hindi: "मॉड्यूल उपलब्ध हैं",
        },
        untitled: {
            English: "Untitled",
            Hindi: "शीर्षकहीन",
        },
        menuTitles: {
            sewa: {
                English: "Sewa",
                Hindi: "सेवा",
            },
            "sewa-dal": {
                English: "Sewa Dal",
                Hindi: "सेवा दल",
            },
            "sewa-category": {
                English: "Sewa Kshetras",
                Hindi: "सेवा क्षेत्र",
            },
        },
    },

    /* ================= ADMIN: SEWA CATEGORY MASTER ================= */

    sewaCategoryMaster: {
        pageTitle: {
            English: "Sewa Kshetras",
            Hindi: "सेवा क्षेत्र",
        },
        searchPlaceholder: {
            English: "Search By Sewa Kshetras Name",
            Hindi: "सेवा क्षेत्र नाम से खोजें",
        },
        addButton: {
            English: "Sewa Kshetras",
            Hindi: "सेवा क्षेत्र जोड़ें",
        },
        addDialogTitle: {
            English: "Add Sewa Kshetras",
            Hindi: "सेवा क्षेत्र जोड़ें",
        },
        updateDialogTitle: {
            English: "Update Sewa Kshetras",
            Hindi: "सेवा क्षेत्र अपडेट करें",
        },
        deleteDialogTitle: {
            English: "Delete Sewa Kshetras",
            Hindi: "सेवा क्षेत्र हटाएं",
        },
        deleteConfirmMessage: {
            English: "Are you sure you want to delete this Sewa Kshetras?",
            Hindi: "क्या आप वाकई इस सेवा क्षेत्र को हटाना चाहते हैं?",
        },
        active: {
            English: "Active",
            Hindi: "सक्रिय",
        },
        headCells: {
            srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
            kshetraName: { English: "Kshetras Name", Hindi: "क्षेत्र का नाम" },
            type: { English: "Type", Hindi: "प्रकार" },
            status: { English: "Status", Hindi: "स्थिति" },
            createdDate: { English: "Created Date", Hindi: "बनाई गई तिथि" },
            action: { English: "Action", Hindi: "कार्रवाई" },
        },
    },

    somethingWentWrong: {
        English: "Something Went Wrong",
        Hindi: "कुछ गलत हो गया"
    },

    projectDetailsPage: {
        srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
        addKpi: { English: "Add KPI", Hindi: "केपीआई जोड़ें" },
        editKpi: { English: "Edit KPI", Hindi: "केपीआई संपादित करें" },
        kpiName: { English: "KPI Name", Hindi: "केपीआई का नाम" },
        category: { English: "Category", Hindi: "श्रेणी" },
        target: { English: "Target", Hindi: "लक्ष्य" },
        actual: { English: "Actual", Hindi: "वास्तविक" },
        action: { English: "Action", Hindi: "कार्रवाई" },
        kpiList: { English: "KPI List", Hindi: "केपीआई सूची" },
        projectDetails: { English: "Project Details", Hindi: "परियोजना विवरण" },
    },

    /* ================= ADMIN: USER ACTIVITY LOGS ================= */

    userActivityLogs: {
        approvedBy: { English: "Approved", Hindi: "स्वीकृत" },
        by: { English: "By", Hindi: "द्वारा" },
        addedUnder: { English: "added under", Hindi: "के अंतर्गत जोड़ा गया" },
        compliancePending: { English: "Compliance Pending", Hindi: "अनुपालन लंबित" },
        registered: { English: "Registered", Hindi: "पंजीकृत" },
        asA: { English: "As A", Hindi: "के रूप में" },
        societyMember: { English: "Society Member", Hindi: "सोसाइटी सदस्य" },
        ngoUser: { English: "NGO User", Hindi: "एनजीओ उपयोगकर्ता" },
        rejected: { English: "Rejected", Hindi: "अस्वीकृत" },
        updated: { English: "Updated", Hindi: "अद्यतन किया गया" },
        detailsWhileUnder: { English: "details while under", Hindi: "विवरण, जब तक कि यह अंतर्गत हो" },
        on: { English: "on", Hindi: "पर" },
    },

    /* ================= ADMIN: CSR CELL USER LIST ================= */

    csrCellUserList: {
        pageTitle: { English: "CSR Cell", Hindi: "सीएसआर सेल" },
        searchPlaceholder: { English: "Search By Name", Hindi: "नाम से खोजें" },
        addButton: { English: "CSR Cell User", Hindi: "सीएसआर सेल उपयोगकर्ता जोड़ें" },
        addDialogTitle: { English: "Add CSR Cell User", Hindi: "सीएसआर सेल उपयोगकर्ता जोड़ें" },
        updateDialogTitle: { English: "Update CSR Cell User", Hindi: "सीएसआर सेल उपयोगकर्ता अपडेट करें" },
        viewDocument: { English: "View Document", Hindi: "दस्तावेज़ देखें" },
        departmentCertificate: { English: "Department Certificate", Hindi: "विभाग प्रमाणपत्र" },
        edit: { English: "Edit", Hindi: "संपादित करें" },
        visitWebsite: { English: "Visit Website", Hindi: "वेबसाइट पर जाएं" },
        headCells: {
            srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
            name: { English: "Name", Hindi: "नाम" },
            designation: { English: "Designation", Hindi: "पदनाम" },
            email: { English: "Email", Hindi: "ईमेल" },
            mobile: { English: "Mobile", Hindi: "मोबाइल" },
            address: { English: "Address", Hindi: "पता" },
            action: { English: "Action", Hindi: "कार्रवाई" },
        },
    },

    /* ================= ADMIN: VOLUNTEER USER LIST ================= */

    volunteerUserList: {
        pageTitle: { English: "Volunteer Users", Hindi: "स्वयंसेवक उपयोगकर्ता" },
        searchPlaceholder: { English: "Search By Volunteer Name", Hindi: "स्वयंसेवक नाम से खोजें" },
        headCells: {
            srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
            volunteerName: { English: "Volunteer Name", Hindi: "स्वयंसेवक का नाम" },
            categoryName: { English: "Category Name", Hindi: "श्रेणी का नाम" },
            email: { English: "Email", Hindi: "ईमेल" },
            contact: { English: "Contact", Hindi: "संपर्क" },
            education: { English: "Education", Hindi: "शिक्षा" },
            designation: { English: "Designation", Hindi: "पदनाम" },
            roleAssigned: { English: "Role Assigned", Hindi: "नियुक्त भूमिका" },
        },
    },

    /* ================= ADMIN: USER CHARTS ================= */

    userCharts: {
        usersStatus: { English: "Users Status", Hindi: "उपयोगकर्ता स्थिति" },
        monthlyProgressTitle: { English: "Monthly Progress", Hindi: "मासिक प्रगति" },
        monthlyProgress: {
            registered: { English: "Registered", Hindi: "पंजीकृत" },
            approved: { English: "Approved", Hindi: "स्वीकृत" },
        },
        userType: {
            title: { English: "Users Type", Hindi: "उपयोगकर्ता प्रकार" },
            donor: { English: "Sewa Partner", Hindi: "सेवा प्रदाता" },
            ngo: { English: "NGO", Hindi: "एनजीओ" },
        },
    },

    /* ================= ADMIN: PROJECT STATUS PIE CHART ================= */

    projectStatusChart: {
        title: {
            English: "Project Status",
            Hindi: "परियोजना स्थिति"
        },
        pending: {
            English: "Pending",
            Hindi: "लंबित"
        },
        approved: {
            English: "Approved",
            Hindi: "स्वीकृत"
        },
        rejected: {
            English: "Rejected",
            Hindi: "अस्वीकृत"
        }
    },

    /* ================= ADMIN: THEMES MASTER ================= */

    themesMaster: {
        pageTitle: {
            English: "Theme Masters",
            Hindi: "थीम मास्टर",
        },
        searchPlaceholder: {
            English: "Search By Theme Name",
            Hindi: "थीम नाम से खोजें",
        },
        addButton: {
            English: "Themes",
            Hindi: "थीम जोड़ें",
        },
        addDialogTitle: {
            English: "Add Themes",
            Hindi: "थीम जोड़ें",
        },
        updateDialogTitle: {
            English: "Update Themes",
            Hindi: "थीम अपडेट करें",
        },
        updateStatusDialogTitle: {
            English: "Update Theme Status",
            Hindi: "थीम स्थिति अपडेट करें",
        },
        deleteDialogTitle: {
            English: "Delete Themes",
            Hindi: "थीम हटाएं",
        },
        deleteConfirmMessage: {
            English: "Are you sure you want to delete this Themes?",
            Hindi: "क्या आप वाकई इस थीम को हटाना चाहते हैं?",
        },
        headCells: {
            srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
            themeName: { English: "Theme Name", Hindi: "थीम का नाम" },
            category: { English: "Category", Hindi: "श्रेणी" },
            description: { English: "Description", Hindi: "विवरण" },
            status: { English: "Status", Hindi: "स्थिति" },
            action: { English: "Action", Hindi: "कार्रवाई" },
        },
    },

    /* ================= ADMIN: SEWA DAL MASTER ================= */

    sewaDalMaster: {
        pageTitle: {
            English: "Sewa Dal",
            Hindi: "सेवा दल",
        },
        searchPlaceholder: {
            English: "Search By Sewa Dal Name",
            Hindi: "सेवा दल नाम से खोजें",
        },
        addButton: {
            English: "Sewa Dal",
            Hindi: "सेवा दल जोड़ें",
        },
        addDialogTitle: {
            English: "Add Sewa Dal",
            Hindi: "सेवा दल जोड़ें",
        },
        updateDialogTitle: {
            English: "Update Sewa Dal",
            Hindi: "सेवा दल अपडेट करें",
        },
        deleteDialogTitle: {
            English: "Delete Sewa Dal",
            Hindi: "सेवा दल हटाएं",
        },
        deleteConfirmMessage: {
            English: "Are you sure you want to delete this Sewa Dal?",
            Hindi: "क्या आप वाकई इस सेवा दल को हटाना चाहते हैं?",
        },
        headCells: {
            srNo: { English: "Sr No.", Hindi: "क्रम संख्या" },
            memberName: { English: "Member Name", Hindi: "सदस्य का नाम" },
            category: { English: "Category", Hindi: "श्रेणी" },
            contact: { English: "Contact", Hindi: "संपर्क" },
            email: { English: "Email", Hindi: "ईमेल" },
            designation: { English: "Designation", Hindi: "पदनाम" },
            region: { English: "Region", Hindi: "क्षेत्र" },
            action: { English: "Action", Hindi: "कार्रवाई" },
        },
    },

    /* ================= ADMIN: CSR COMMITTEE ================= */

    adminCsrCommittee: {
        pageTitle: {
            English: "CSR Cell",
            Hindi: "सीएसआर सेल",
        },
        snColumn: {
            English: "S.N.",
            Hindi: "क्र.सं.",
        },
        designationColumn: {
            English: "DESIGNATION",
            Hindi: "पदनाम",
        },
        departmentColumn: {
            English: "DEPARTMENT",
            Hindi: "विभाग",
        },
    },

}

export default PageLang;
